/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useRef, useState } from "react"
import _ from "lodash"

// Context
import { UserContext } from "../../context/userContext"

//Appointments utils and components
import {
  cancelAppointment,
  createNewAppointment,
  createNewOrgAppointment,
  getAllAppointments,
  getAllMinifiedAppointments,
  getAvailabilities,
  declineParticipantAppointment,
  claimOrgAppointment,
  setAvailability,
  deleteAvailability,
  deleteOrgAppointment,
  deleteOrgController,
  updateAppointment,
  editOrgAppointment,
  editAvailability,
} from "../../components/Appointments/AppointmentsApi"
import {
  formatDate,
  timezones,
  durations,
  groupFilterTemplate,
  isFormFieldValid,
  customStyles,
  editChannelSelect,
  engagementChannels,
  formatAvailDate,
  formatAvailTime,
  formatOrgCalDate,
  formatRecurringRules,
  getDateKey,
  reformatAppointment,
  reformatAvailability,
  acceptRequestedSchedule,
  mainViews,
  orgCalListViewOptions,
  staffCalListViewOptions,
  extractSoarId,
  getDate,
  getDateTimezone,
  formatDateTimeActual,
  formatAvailTimezone,
} from "../../components/Appointments/utils"
import {
  getScheduledTime,
  generateFutureRecurringEvents,
  generateFutureRecurringEventsForControllers,
} from "../../components/Appointments/utilsRecurringControllers"
import AppointmentsTablePending from "./AppointmentsTablePending"

//prime react
import { Toast } from "primereact/toast"
import { Dialog } from "primereact/dialog"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { MultiSelect } from "primereact/multiselect"
import { TabView, TabPanel } from "primereact/tabview"
import { Calendar } from "primereact/calendar"
import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"
import { classNames } from "primereact/utils"
import { ToggleButton } from "primereact/togglebutton"

//Styles
import styles from "../../styles/Home-Staff.module.css"

import { useLazyQuery, useQuery } from "@apollo/client"

import { useFormik } from "formik"

import { GET_USERS, GET_SERVICES } from "./taskQueries"
import "./lib/cron.js"
import $ from "jquery"

//Routes
import ROUTES from "../Routes/routesContants"
import { useNavigate } from "react-router-dom"

//SOAR components
import { ProgressSpinner } from "primereact/progressspinner"

import { LogError } from "../../helpers/logger"
import { DateTime } from "luxon"
import { applyAppointmentFilters, filterServiceTemplates } from "./utilsFilters"
import AppointmentsTableDeclined from "./AppointmentsTableDeclined"
import AppointmentsFormCron from "./AppointmentsFormCron.js"

export default function Appointments() {
  const userCtx = useContext(UserContext)
  const uid = userCtx.session.user.staff_id
  const organization_id = userCtx.session.user.organization_id
  const navigate = useNavigate()
  const [isRefreshDone, setIsRefreshDone] = useState(false)
  const [participants, setParticipants] = useState([])
  const [users, setUsers] = useState([])

  const [isLoadingParticipantLink, setIsLoadingParticipantLink] =
    useState(false)
  const [isLoadingAppointments, setIsLoadingAppointments] = useState(true)
  const [isLoadingStaffAppointments, setIsLoadingStaffAppointments] =
    useState(true)

  const [show, setShow] = useState(false)
  const [activeMainIndex, setActiveMainIndex] = useState(mainViews[0])
  const [activeOrgCalendarIndex, setActiveOrgCalendarIndex] = useState(0)
  const [activeStaffCalendarIndex, setActiveStaffCalendarIndex] = useState(0)
  const [activeStaffSchedulingIndex, setActiveStaffSchedulingIndex] =
    useState(0)
  const [activeStaffAvailabilityIndex, setActiveStaffAvailabilityIndex] =
    useState(0)
  const [selectedDateView, setSelectedDateView] = useState(null)

  const [appointments, setAppointments] = useState({})
  const [recurringAppointments, setRecurringAppointments] = useState([])
  const [availableAppointments, setAvailableAppointments] = useState([])
  const [claimedAppointments, setClaimedAppointments] = useState([])
  const [unclaimedAppointments, setUnclaimedAppointments] = useState([])
  const [pastAppointments, setPastAppointments] = useState([])
  const [upcomingAppointments, setUpcomingAppointments] = useState([])
  const [pendingAppointments, setPendingAppointments] = useState([])
  const [activeAvailabilities, setActiveAvailabilities] = useState([])
  const [pastAvailabilities, setPastAvailabilities] = useState([])
  const [acceptingOrgAppt, setAcceptingOrgAppt] = useState(null)
  const [recurringOrgControllers, setRecurringOrgControllers] = useState([])
  const [recurringStaffControllers, setRecurringStaffControllers] = useState([])
  const [services, setServices] = useState([])

  const [cached_appointments, setCachedAppointments] = useState({})
  const [cached_recurringAppointments, setCachedRecurringAppointments] =
    useState([])
  const [cached_availableAppointments, setCachedAvailableAppointments] =
    useState(null)
  const [cached_claimedAppointments, setCachedClaimedAppointments] =
    useState(null)
  const [cached_unclaimedAppointments, setCachedUnclaimedAppointments] =
    useState([])
  const [cached_pastAppointments, setCachedPastAppointments] = useState([])
  const [cached_upcomingAppointments, setCachedUpcomingAppointments] =
    useState(null)
  const [cached_pendingAppointments, setCachedPendingAppointments] = useState(
    [],
  )
  const [cached_recurringOrgControllers, setCachedRecurringOrgControllers] =
    useState(null)

  const [editingRulesForController, setEditingRulesForController] =
    useState(false)
  const [editingRulesForAvailController, setEditingRulesForAvailController] =
    useState(false)
  const [selectedStaffContext, setSelectedStaffContext] = useState(null)
  const [selectedFilters, setSelectedFilters] = useState([])

  const [groupedFilters, setGroupFilters] = useState(groupFilterTemplate)

  const [activeOrgCalendarArray, setActiveOrgCalendarArray] = useState([])
  const [activeStaffCalendarArray, setActiveStaffCalendarArray] = useState([])
  const [activeOrgCalendarContext, setActiveOrgCalendarContext] = useState(
    "Available Appointments",
  )
  const [activeStaffCalendarContext, setActiveStaffCalendarContext] = useState(
    "Pending Appointments",
  )

  const [activeCron, setActiveCron] = useState(undefined)
  const createAvailabilityCron = useRef(null)
  $(createAvailabilityCron.current).cronBuilder({
    create: true,
    availability: true,
  })

  const [data, setData] = useState({ appointments: [] })
  const [date, setDate] = useState(new Date())
  const [date2, setDate2] = useState([
    DateTime.local().startOf("month").toJSDate(),
    DateTime.local().endOf("month").toJSDate(),
  ])
  const [modalIsOpen, setIsOpen] = useState(false)
  const [apptModalMode, setApptModalMode] = useState("Submit Appointment")
  const [availModalMode, setAvailModalMode] = useState("Set Availability")
  const [availabilityModalIsOpen, setAvailabilityIsOpen] = useState(false)
  const [confirmModalIsOpen, setConfirmIsOpen] = useState(false)
  const toast = useRef(null)

  const [isCalendarView, setIsCalendarView] = useState({
    myCalendar: true,
    orgCalendar: false,
    staffCalendar: false,
  })
  const [confirming, setConfirming] = useState({ mode: "", message: "" })

  const activeAppointment = useFormik({
    initialValues: {
      id: 0,
      serviceName: "Intake Session",
      duration: { code: "30m", name: "30 minutes", mins: "30" },
      engagementChannel: "telephone",
      location: "",
      timezone: {
        code: DateTime.local().toFormat("z"),
        name: timezones.find((x) => x.code === DateTime.local().toFormat("z"))
          ? timezones.find((x) => x.code === DateTime.local().toFormat("z"))
              .name
          : timezones[0].name,
      },
      isRecurring: false,
      startDate: new Date(),
      startTime: new Date(),
      endTime: new Date(),
      cron: null,
      participant: participants[0],
      sendEmailNotifications: true,
      sendSMSNotifications: true,
      cronDescription: "",
      isRecurringController: false,
    },
    validate: (data) => {
      let errors = {}
      if (!data.startDate) {
        errors.startDate = "Date is required."
      }

      if (!data.startTime) {
        errors.startTime = "Time is required."
      }

      if (!data.participant) {
        errors.participant = "Participant is required."
      }

      return errors
    },
    onSubmit: (data) => {
      activeAppointment.resetForm()
    },
  })

  const activeAvailability = useFormik({
    initialValues: {
      id: 0,
      availableDate: new Date(),
      endTime: null,
      startTime: null,
      startDate: new Date(),
      endDate: new Date(),
      timezone: {
        code: DateTime.local().toFormat("z"),
        name: timezones.find((x) => x.code === DateTime.local().toFormat("z"))
          ? timezones.find((x) => x.code === DateTime.local().toFormat("z"))
              .name
          : timezones[0].name,
      },
      appointmentBuffer: { code: "30m", name: "30 minutes" },
      isRecurring: false,
      recurringStartDate: new Date(),
      recurringEndDate: new Date(),
      recurringStartTime: new Date(),
      recurringEndTime: new Date(),
      cron: "",
    },
    validate: (data) => {
      let errors = {}
      if (!data.isRecurring) {
        if (!data.availableDate) {
          errors.availableDate = "Date is required."
        }

        if (!data.startTime) {
          errors.startTime = "Start time is required."
        }

        if (!data.endTime) {
          errors.endTime = "End time is required."
        }
      }

      return errors
    },
    onSubmit: (data) => {
      activeAppointment.resetForm()
    },
  })

  const getInitializedSelectedDateView = () => {
    // If no date range is selected, set to defaults and return
    if (!selectedDateView || !selectedDateView.from || !selectedDateView.to) {
      return setSelectedDateViewValue() // applies defaults
    }
    return selectedDateView
  }

  function toggleConfirmOrgClaim(
    id,
    fromRecurring,
    startDate,
    endDate,
    caseId,
  ) {
    setAcceptingOrgAppt({ id, fromRecurring, startDate, endDate, caseId })
    setConfirming({
      mode: "availableAppointment",
      message: "Are you sure you want to accept this appointment?",
    })
    setConfirmIsOpen(true)
  }

  async function acceptAvailableAppointment() {
    try {
      let peerInfo = {
        peerEmail: userCtx.session.user.staff_email_address,
        peerName:
          userCtx.session.user.staff_name_first +
          " " +
          userCtx.session.user.staff_name_last,
        peerId: userCtx.session.user.staff_alias,
        fromSoar: true,
        alias: {
          orgAlias: organization_id,
          staffAlias: userCtx.session.user.staff_id,
          participantAlias: participants.find(
            (x) => +x.code === +acceptingOrgAppt.caseId,
          )?.alias,
        },
      }

      let res = await claimOrgAppointment(
        userCtx.tokens.getAppointmentsToken(),
        acceptingOrgAppt.id,
        peerInfo,
        acceptingOrgAppt.fromRecurring,
        acceptingOrgAppt.startDate,
        acceptingOrgAppt.endDate,
      )

      if (res.successful) {
        //await declineBooking(id);
        refresh()
        //await getRecurringAppointments();

        toast.current.show({
          severity: "success",
          detail: `Successfully claimed organization appointment`,
          life: 3000,
        })
        setConfirmIsOpen(false)
      } else {
        toast.current.show({
          severity: "error",
          detail: res.error,
          life: 9000,
        })
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        detail: error.message,
        life: 9000,
      })
    }
  }

  async function getAppointments() {
    try {
      setIsLoadingAppointments(true)

      // If no date range is selected, set to defaults
      let currentDateView = getInitializedSelectedDateView()

      let appts = await getAllAppointments(
        userCtx.tokens.getAppointmentsToken(),
        userCtx.session.user.staff_alias,
        DateTime.fromJSDate(currentDateView.from).toFormat("yyyy-MM-dd"),
        DateTime.fromJSDate(currentDateView.to)
          .plus({
            days: 14,
          })
          .toFormat("yyyy-MM-dd"),
        userCtx.session.user.organization_alias,
      )
      if (appts.successful) {
        appts.data.appointments.forEach((appointment) => {
          let dateKey = getDateKey(appointment.startDateTime)

          appointment.appointment_engagementChannel =
            appointment.metadata.engagementChannel
          appointment.startDateTimeActual = DateTime.fromFormat(
            appointment.startDateTime,
            dateKey,
            { zone: appointment.timezone || appointment.timezoneName },
          ).toJSDate()
          appointment.appointment_fromBehalfOf =
            appointment.metadata.fromBehalfOf
          appointment.scheduledTime = getScheduledTime(appointment)
        })

        let recurrings = appts.data.recurringAppointments
          .filter(
            (x) =>
              +x.recurringController.orgId ===
              +userCtx.session.user.organization_alias,
          )
          .map((x) => {
            let dateKey = getDateKey(x.startDateTime)

            let startDateTimeActual = DateTime.fromFormat(
              x.startDateTime,
              dateKey,
              { zone: x.timezone || x.timezoneName },
            )

            let tempSplit = x.recurringController.cronDescription.split(" | ")
            tempSplit[2] = startDateTimeActual
              .setZone(DateTime.local().toFormat("z"))
              .toFormat("hh:mm a")
            x.recurringController.cronDescription = tempSplit.join(" | ")

            tempSplit[2] = startDateTimeActual.toFormat("hh:mm a")
            x.recurringController.cronDescriptionActual = tempSplit.join(" | ")

            x.isRecurringController = true

            x.recurringController.scheduledTime =
              DateTime.fromFormat(
                x.startDateTime,
                getDateKey(x.startDateTime),
                { zone: x.timezoneName || x.timezone },
              )
                .setZone(DateTime.local().toFormat("z"))
                .toFormat("h:mm a") +
              "-" +
              DateTime.fromFormat(x.endDateTime, getDateKey(x.endDateTime), {
                zone: x.timezoneName || x.timezone,
              })
                .setZone(DateTime.local().toFormat("z"))
                .toFormat("h:mm a")

            return x
          })
        setRecurringAppointments(recurrings)
        let futureAppts = generateFutureRecurringEvents(
          recurrings,
          appts.data.appointments,
          participants,
          currentDateView.from,
          currentDateView.to,
        )

        setAppointments({
          ...appts.data,
          appointments: appts.data.appointments
            .filter(
              (x) =>
                +x.metadata.orgId === +userCtx.session.user.organization_alias,
            )
            .concat(futureAppts),
        })
      }

      setIsLoadingAppointments(false)
    } catch (error) {
      LogError("Unable to load appointments", error)
      userCtx.setNotificationError("Unable to load appointments")
      setAppointments({})
      setIsLoadingAppointments(false)
    }
  }

  async function getAvailableAppointments() {
    try {
      // If no date range is selected, set to defaults
      let currentDateView = getInitializedSelectedDateView()

      let res = await getAllMinifiedAppointments(
        userCtx.tokens.getAppointmentsToken(),
        null,
        DateTime.fromJSDate(currentDateView.from).toFormat("yyyy-MM-dd"),
        DateTime.fromJSDate(currentDateView.to).toFormat("yyyy-MM-dd"),
        null,
        false,
        true,
        userCtx.session.user.organization_alias,
      )

      if (res.successful) {
        setUnclaimedAppointments(
          res.data
            .filter(
              (x) =>
                DateTime.fromFormat(
                  x.startDateTime,
                  "MM/dd/yyyy hh:mm a",
                ).toUnixInteger() < DateTime.local().toUnixInteger(),
            )
            .reverse(),
        )

        setClaimedAppointments(
          res.data.filter(
            (x) =>
              DateTime.fromFormat(
                x.startDateTime,
                "MM/dd/yyyy hh:mm a",
              ).toUnixInteger() > DateTime.local().toUnixInteger() &&
              !x.isUnclaimed,
          ),
        )

        getRecurringAvailableAppointments(
          res.data
            .map((x) => {
              x = formatDate(x)
              x.startDateTimeActual = getDate(x.startDateTime)
              return x
            })
            .filter(
              (x) =>
                getDate(x.startDateTime).toUnixInteger() >
                DateTime.local().toUnixInteger(),
            ),
        )
      } else {
        getRecurringAvailableAppointments([])
      }
    } catch (error) {
      LogError("Unable to load available appointments", error)
      userCtx.setNotificationError("Unable to load available appointments")
      setUnclaimedAppointments([])
      setClaimedAppointments([])
      getRecurringAvailableAppointments([])
    }
  }

  async function loadAvailabilities() {
    let res5 = await getAvailabilities(
      userCtx.tokens.getAppointmentsToken(),
      selectedStaffContext.staff_email_address,
    )
    if (res5.successful && res5.data.length > 0) {
      setActiveAvailabilities(
        res5.data.filter((x) => {
          if (!x.isRecurring)
            return (
              getDate(x.individualEndDate).toUnixInteger() >
              DateTime.local().toUnixInteger()
            )
          else
            return (
              DateTime.fromFormat(
                getDate(x.recurringEndDate).toFormat("MM/dd/yyyy") +
                  " " +
                  x.recurringEndTime,
                "MM/dd/yyyy hh:mm a",
              ).toUnixInteger() > DateTime.local().toUnixInteger()
            )
        }),
      )
      setPastAvailabilities(
        res5.data.filter((x) => {
          if (!x.isRecurring)
            return (
              DateTime.fromFormat(
                x.individualEndDate,
                "yyyy-MM-dd hh:mm:ss ZZ",
              ).toUnixInteger() < DateTime.local().toUnixInteger()
            )
          else
            return (
              DateTime.fromFormat(
                DateTime.fromFormat(
                  x.recurringEndDate,
                  "yyyy-MM-dd hh:mm:ss ZZ",
                ).toFormat("MM/dd/yyyy") +
                  " " +
                  x.recurringEndTime,
                "MM/dd/yyyy h:mm a",
              ).toUnixInteger() < DateTime.local().toUnixInteger()
            )
        }),
      )
    }
  }

  async function getStaffAppointments() {
    try {
      setIsLoadingStaffAppointments(true)

      // If no date range is selected, set to defaults
      let currentDateView = getInitializedSelectedDateView()

      let res2 = await getAllMinifiedAppointments(
        userCtx.tokens.getAppointmentsToken(),
        selectedStaffContext.staff_alias,
        DateTime.fromJSDate(currentDateView.from).toFormat("yyyy-MM-dd"),
        DateTime.fromJSDate(currentDateView.to).toFormat("yyyy-MM-dd"),
        null,
        false,
        false,
        userCtx.session.user.organization_alias,
      )
      if (res2.successful) {
        getRecurringStaffAppointments(res2.data)
      } else {
        setPastAppointments([])
        getRecurringStaffAppointments([])
      }

      setIsLoadingStaffAppointments(false)
    } catch (error) {
      LogError("Unable to load staff appointments", error)
      userCtx.setNotificationError("Unable to load staff appointments")
      //Reset variables:
      setPastAppointments([])
      setRecurringStaffControllers([])
      setUpcomingAppointments([])
      setIsLoadingStaffAppointments(false)
    }
  }

  async function getPendingAppointments() {
    // If no date range is selected, set to defaults
    let currentDateView = getInitializedSelectedDateView()

    let res4 = await getAllMinifiedAppointments(
      userCtx.tokens.getAppointmentsToken(),
      selectedStaffContext.staff_alias,
      DateTime.fromJSDate(currentDateView.from)
        .minus({ days: 120 })
        .toFormat("yyyy-MM-dd"),
      DateTime.fromJSDate(currentDateView.to).toFormat("yyyy-MM-dd"),
      null,
      false,
      true,
      userCtx.session.user.organization_alias,
    )
    if (res4.successful) {
      setPendingAppointments(
        res4.data.map((x) => {
          x = formatDate(x)
          return x
        }),
      )
    }
  }

  async function getRecurringAvailableAppointments(orgAppts) {
    // If no date range is selected, set to defaults
    let currentDateView = getInitializedSelectedDateView()

    let availableAppts = orgAppts.filter((x) => x.isUnclaimed)
    let claimedAppts = orgAppts.filter((x) => !x.isUnclaimed)
    let start = DateTime.fromJSDate(currentDateView.from)
    let end = DateTime.fromJSDate(currentDateView.to)
    let res = await getAllMinifiedAppointments(
      userCtx.tokens.getAppointmentsToken(),
      null,
      start.toFormat("yyyy-MM-dd"),
      end.toFormat("yyyy-MM-dd"),
      null,
      true,
      null,
      userCtx.session.user.organization_alias,
    )
    if (res.successful) {
      let recurringAppts = res.data.map((x) => {
        x.isRecurringController = true
        return x
      })

      let available = [],
        claimed = []

      for (let obj of recurringAppts) {
        let frequency = obj.frequency.split(" | ")
        let newFreq = frequency.slice(1)
        obj.startDateTime = obj.startDate
        obj.endDateTime = obj.endDate

        let localFreq = [...newFreq]
        localFreq[1] = getDate(obj.startDate)
          .setZone(DateTime.local().toFormat("z"))
          .toFormat("hh:mm a")
        obj.localCronDescription = localFreq.join(" | ")
        obj.newFreq = newFreq.join(" | ")

        const futureAppointments = generateFutureRecurringEventsForControllers(
          [obj],
          availableAppointments,
          currentDateView?.from,
          currentDateView?.to,
        )

        for (let futureAppointment of futureAppointments) {
          let isClaimedDate = false
          let claimedDateBy

          if (obj.claimedDates === undefined || obj.claimedDates === null) {
            obj.claimedDates = []
          } else if (typeof obj.claimedDates === "string") {
            obj.claimedDates = obj.claimedDates.split(",")
          }

          for (let claimedDate of obj.claimedDates) {
            if (
              getDate(futureAppointment.startDateTime).valueOf() ===
              parseInt(claimedDate)
            ) {
              isClaimedDate = true
              claimedDateBy = claimedDate.split(":")[1]
            }
          }

          //delete obj.startDateTime
          futureAppointment.startDateTimeActual = getDate(
            futureAppointment.startDateTime,
          ).setZone(DateTime.local().zoneName)

          futureAppointment.id = obj.id

          let entry = formatDate(futureAppointment)
          entry.isRecurringController = false
          if (!isClaimedDate) {
            available.push(entry)
          } else {
            entry.claimedBy = claimedDateBy
            claimed.push(entry)
          }
        }
      }
      setRecurringOrgControllers(recurringAppts)
      setAvailableAppointments([...availableAppts, ...available])
      setClaimedAppointments([...claimedAppts, ...claimed])
    } else {
      setRecurringOrgControllers([])
      setAvailableAppointments(availableAppts || [])
      setClaimedAppointments(claimedAppts || [])
    }
  }

  async function getRecurringStaffAppointments(upcoming) {
    // If no date range is selected, set to defaults
    let currentDateView = getInitializedSelectedDateView()

    let start = DateTime.fromJSDate(currentDateView.from)
    let end = DateTime.fromJSDate(currentDateView.to)

    //Format upcoming appointments & filter out old appointments
    const formattedUpcoming = upcoming
      .map((x) => {
        x = formatDate(x)
        return x
      })
      .filter(
        (x) =>
          getDate(x.startDateTime).toUnixInteger() >
          DateTime.local().toUnixInteger(),
      )

    //Format past appointments & filter out upcoming appointments
    const formattedPast = upcoming
      .map((x) => {
        x = formatDate(x)
        return x
      })
      .filter(
        (x) =>
          getDate(x.startDateTime).toUnixInteger() <
          DateTime.local().toUnixInteger(),
      )

    let res = await getAllMinifiedAppointments(
      userCtx.tokens.getAppointmentsToken(),
      selectedStaffContext.staff_alias || selectedStaffContext.staff_alias,
      start.toFormat("yyyy-MM-dd"),
      end.toFormat("yyyy-MM-dd"),
      null,
      true,
      null,
      userCtx.session.user.organization_alias,
    )

    if (res.successful) {
      let recurringAppts = res.data

      let generated = []
      for (let obj of recurringAppts) {
        let frequency = obj.frequency.split(" | ")
        let newFreq

        if (
          frequency[1] === "Daily" &&
          frequency[frequency.length - 1].includes(":")
        ) {
          newFreq = frequency[1]
        } else {
          newFreq = frequency[1] + " | " + frequency[frequency.length - 1]
        }

        obj.newFreq = newFreq
        obj = formatDate(obj)

        const futureAppointments = generateFutureRecurringEventsForControllers(
          [obj],
          upcoming,
          currentDateView?.from,
          currentDateView?.to,
        )

        generated.push(...futureAppointments)
      }

      setRecurringStaffControllers(recurringAppts)

      const pastGenerated = generated.filter(
        (x) => DateTime.fromISO(x.startDateTime) < DateTime.local(),
      )
      const upcomingGenerated = generated.filter(
        (x) => DateTime.fromISO(x.startDateTime) >= DateTime.local(),
      )

      setPastAppointments([...formattedPast, ...pastGenerated])
      setUpcomingAppointments([...formattedUpcoming, ...upcomingGenerated])
    } else {
      setRecurringStaffControllers([])
      setUpcomingAppointments(formattedUpcoming)
      setPastAppointments(formattedPast)
    }
  }

  function setStaffAndParticipants(data) {
    let userz = data.users
      .filter((x) => x.organization_id === userCtx.session.user.organization_id)
      .map((x) => {
        return {
          id: x.staff_id,
          staff_id: x.staff_id,
          participant_id: undefined,
          staff_alias: x.staff_alias,
          status: x.staff_user_status,
          staff_email_address: x.staff_email_address,
          optionName: `${x.staff_name_first} ${x.staff_name_last}`,
          name2: `${x.staff_name_first} ${x.staff_name_last}`,
          staff_name_first: x.staff_name_first,
          staff_name_last: x.staff_name_last,
          userRole: "Staff",
          organization_id: x.organization_id,
          organization_alias: x.organization_alias,
        }
      })

    if (!userz.find((x) => x.id === userCtx.session.user.staff_id)) {
      userz.push({
        id: userCtx.session.user.staff_id,
        staff_id: userCtx.session.user.staff_id,
        participant_id: undefined,
        staff_alias: userCtx.session.user.staff_alias,
        status: userCtx.session.user.staff_user_status,
        staff_email_address: userCtx.session.user.staff_email_address,
        optionName: `${userCtx.session.user.staff_name_first} ${userCtx.session.user.staff_name_last}`,
        name2: `${userCtx.session.user.staff_name_first} ${userCtx.session.user.staff_name_last}`,
        staff_name_first: userCtx.session.user.staff_name_first,
        staff_name_last: userCtx.session.user.staff_name_last,
        userRole: "Staff",
        organization_id: userCtx.session.user.organization_id,
        organization_alias: userCtx.session.user.organization_alias,
      })
    }

    let parts = data.participants
      //.filter((x) => !x.participant_membership_status.includes("Inactive"))
      .map((x) => {
        return {
          participant_id: x.participant_id,
          alias: x.participant_alias,
          status: x.participant_member_status,
          email: x.participant_email_account,
          phone: x.participant_phone_primary,
          optionName: `${x.participant_name_first} ${x.participant_name_last} ${
            x.participant_email_account
              ? ` [${x.participant_email_account}]`
              : ""
          }]`,
          name2: `${x.participant_name_first} ${x.participant_name_last}`,
          firstName: x.participant_name_first,
          lastName: x.participant_name_last,
          userRole: "Participants",
        }
      })
    setUsers(userz)

    const sortParticipant = (participant1, participant2) => {
      const name1 = participant1.name2?.toLowerCase() || ""
      const name2 = participant2.name2?.toLowerCase() || ""
      let result = 0
      if (name1 > name2) {
        result = 1
      } else if (name2 > name1) {
        result = -1
      }

      return result
    }

    setParticipants(
      parts
        .sort((a, b) => sortParticipant(a, b))
        .map((x) => {
          return {
            code: x.alias,
            name: x.name2,
            firstName: x.firstName,
            lastName: x.lastName,
            email: x.email,
            phone: x.phone,
            alias: x.participant_id,
          }
        }),
    )
    activeAppointment.setFieldValue("participant", participants[0])
  }

  function setApptServices(data) {
    const servicesFromTemplates = filterServiceTemplates(
      data.getTemplatesByOrganization,
    ).map((x) => x.template_title)

    setServices(servicesFromTemplates)

    let modifiedGroup = groupedFilters

    modifiedGroup[0].items = servicesFromTemplates.map((x) => {
      return { label: x, value: x }
    })
    setGroupFilters(modifiedGroup)
  }

  const setSelectedDateViewValue = (fromDate, toDate) => {
    if (!fromDate) {
      fromDate = DateTime.local().startOf("day").toJSDate()
    } else {
      fromDate = DateTime.fromJSDate(fromDate).startOf("day").toJSDate()
    }

    if (!toDate) {
      //If no end date is specified, set the date to the end of the month
      toDate = DateTime.fromJSDate(fromDate).endOf("month").toJSDate()
    }

    const newSelectedDateViewValue = { from: fromDate, to: toDate }
    setSelectedDateView(newSelectedDateViewValue)
    return newSelectedDateViewValue
  }

  useEffect(() => {
    if (appointments.appointments !== undefined) updateList(date)
  }, [appointments])

  useEffect(() => {
    if (recurringStaffControllers !== null) {
      if (cached_appointments.appointments === undefined && isRefreshDone) {
        setCachedAppointments(appointments)
        setCachedRecurringAppointments(recurringAppointments)
        setCachedAvailableAppointments(availableAppointments)
        setCachedClaimedAppointments(claimedAppointments)
        setCachedUnclaimedAppointments(unclaimedAppointments)
        setCachedPastAppointments(pastAppointments)
        setCachedUpcomingAppointments(upcomingAppointments)
        setCachedPendingAppointments(pendingAppointments)
        setCachedRecurringOrgControllers(recurringOrgControllers)
        setIsRefreshDone(false)
      } else if (!isRefreshDone) {
        //setCachedPastAppointments(pastAppointments)
        filterAppointments()
        //setCachedPendingAppointments(pendingAppointments)
      }
    }
  }, [isRefreshDone])

  useEffect(() => {
    if (!!selectedDateView) {
      setDate2([selectedDateView.from, selectedDateView.to])

      if (
        userCtx.session.user.staff_alias !== undefined &&
        participants.length > 0
      ) {
        refresh()
      }
    }
  }, [selectedDateView])

  useEffect(() => {
    if (selectedStaffContext === null && users.length > 0) {
      setSelectedStaffContext(
        users.find((x) => x.id === userCtx.session.user.staff_id),
      )
    }

    if (!selectedDateView && users.length > 0 && participants.length > 0) {
      setSelectedDateViewValue(
        DateTime.local()
          .minus(DateTime.local().toFormat("dd") - 1, "days")
          .toJSDate(),
      )
    }
  }, [participants, users])

  const loadSessionTemplates = useCallback(async () => {
    let data_services = await loadSoarSessionTemplates()
    data_services = data_services.data
    setApptServices(data_services)
  }, [userCtx.session.user.organization_id, userCtx.session.labels])

  useEffect(() => {
    loadSessionTemplates()
  }, [loadSessionTemplates])

  useEffect(() => {
    if (userCtx.session.user.staff_alias !== undefined) {
      setAvailableAppointments([])
      setClaimedAppointments([])
      setRecurringOrgControllers([])
      setRecurringStaffControllers([])
      setUpcomingAppointments([])
      setPastAppointments([])
      getAvailableAppointments()
    }
  }, [userCtx.session.user.staff_id]) // Only triggers on actual value change

  useEffect(async () => {
    refresh()
    let data_users = await refetch()
    data_users = data_users.data
    setStaffAndParticipants(data_users)
  }, [])

  useEffect(() => {
    if (selectedStaffContext !== null) {
      setRecurringStaffControllers([])
      setUpcomingAppointments([])
      setPastAppointments([])
      setActiveAvailabilities(null)
      setPastAvailabilities(null)
      setPendingAppointments([])
      setCachedPastAppointments([])
      setCachedUpcomingAppointments([])
      setCachedPendingAppointments([])

      if (selectedDateView && selectedDateView.from && selectedDateView.to) {
        loadAvailabilities()
        getStaffAppointments()
        getPendingAppointments()
        //filterAppointments()
      }
    }
  }, [selectedStaffContext])

  useEffect(() => {
    if (userCtx.toggleAppointment.toggle) {
      if (userCtx.toggleAppointment.page === "availability") {
        setActiveMainIndex(mainViews[2])
        setActiveStaffCalendarIndex(1)
      } else {
        setActiveMainIndex(mainViews[0])
      }
      loadSessionTemplates()
      setShow(true)

      //Reset the toggler for next use
      userCtx.setToggleAppointments({
        ...userCtx.toggleAppointment,
        toggle: false,
      })
    }
  }, [userCtx.toggleAppointment])

  async function refresh() {
    setIsRefreshDone(false)
    setRecurringStaffControllers([])
    setUpcomingAppointments([])
    setPastAppointments([])
    setActiveAvailabilities(null)
    setPastAvailabilities(null)
    setPendingAppointments([])
    setData({ appointments: [] })
    setAppointments({})
    setAvailableAppointments([])

    setCachedAppointments({})
    setCachedRecurringAppointments(null)
    setCachedAvailableAppointments(null)
    setCachedClaimedAppointments(null)
    setCachedUnclaimedAppointments(null)
    setCachedPastAppointments(null)
    setCachedUpcomingAppointments(null)
    setCachedPendingAppointments([])
    setCachedRecurringOrgControllers(null)

    if (selectedDateView && selectedDateView.from && selectedDateView.to) {
      await getAppointments()
      await getStaffAppointments()
      await loadAvailabilities()
      await getAvailableAppointments()
      await getPendingAppointments()

      setIsRefreshDone(true)
    }
  }

  useEffect(() => {
    if (userCtx.refreshTrigger) {
      refresh()
    }
  }, [userCtx.refreshTrigger])

  function openEditModal(data) {
    try {
      setApptModalMode("Edit Appointment")
      setEditingRulesForController(false)

      let cron = ""
      let cronDescription = ""

      if (data.isRecurringController) {
        if (data.recurringController) {
          cron = data.recurringController.cronExpression
          cronDescription = data.recurringController.cronDescription
        } else {
          cron = data?.cron
          cronDescription = data?.frequency
        }
      }

      if (data.recurringController) {
        data.participant = participants.find(
          (x) => +x.code === +data.recurringController.caseId,
        )
      } else if (data.metadata)
        data.participant = participants.find(
          (x) => +x.code === +data.metadata.caseId,
        )
      else data.participant = participants.find((x) => +x.code === +data.caseId)

      const userValues = {
        organization_id: userCtx.session.user.organization_id,
        organization_alias: userCtx.session.user.organization_alias,
        staff_id: userCtx.session.user.staff_id,
        staff_alias: userCtx.session.user.staff_alias,
        staff_name_first: userCtx.session.user.staff_name_first,
        staff_name_last: userCtx.session.user.staff_name_last,
        staff_email_address: userCtx.session.user.staff_email_address,
      }

      const newActiveAppointment = reformatAppointment(
        activeAppointment,
        userValues,
        data,
        true,
        false,
        data.isRecurringController,
        false,
        +activeMainIndex.code === 1,
        cron,
        toast,
      )

      setActiveCron({
        cronValue: cron,
        cronDescription: cronDescription,
      })
      activeAppointment.setValues(newActiveAppointment)
      setIsOpen(true)

      if (!newActiveAppointment.timezone?.name) {
        userCtx.setNotificationError(
          `This appointment has an unknown timezone code: ${newActiveAppointment.timezone?.code}`,
        )
      }
    } catch (error) {
      userCtx.setNotificationError("An error occurred opening the appointment")
      LogError("An error occurred while opening the appointment", error)

      setIsOpen(false)
    }
  }

  function openEditAvailModal(data) {
    setAvailModalMode("Edit Availability")
    setEditingRulesForAvailController(false)

    const userDetail = {
      staff_email_address: userCtx.session.user.staff_email_address,
      staff_name_first: userCtx.session.user.staff_name_first,
      staff_name_last: userCtx.session.user.staff_name_last,
      staff_alias: userCtx.session.user.staff_alias,
      staff_id: userCtx.session.user.staff_id,
    }

    const reformattedValues = reformatAvailability(
      activeAvailability,
      userDetail,
      data,
      true, // forModal
      false, // isEditing
      false, // isRecurringController
      null, //editingRulesForController
      toast,
    )

    activeAvailability.setValues(reformattedValues)
    setAvailabilityIsOpen(true)
  }

  async function cancelAppt(skip = false, toggleConfirmed) {
    let res = {}

    if (toggleConfirmed === false) {
      setConfirming({
        mode: "cancelAppointment",
        message: "Are you sure you want to cancel this appointment? ",
      })
      setConfirmIsOpen(true)
      return
    } else {
      setConfirmIsOpen(false)
    }

    if (!skip) {
      if (+activeMainIndex.code !== 1)
        res = await cancelAppointment(
          userCtx.tokens.getAppointmentsToken(),
          activeAppointment.values.id,
          DateTime.fromJSDate(activeAppointment.values.startDate).valueOf(),
          activeAppointment.values.isRecurringController || false,
        )
      else {
        if (
          +activeOrgCalendarIndex === 3 ||
          (isCalendarView.orgCalendar &&
            activeAppointment.values.isRecurringController)
        )
          res = await deleteOrgController(
            userCtx.tokens.getAppointmentsToken(),
            activeAppointment.values.id,
          )
        else
          res = await deleteOrgAppointment(
            userCtx.tokens.getAppointmentsToken(),
            activeAppointment.values.id,
            activeAppointment.values.isRecurringController === false &&
              (activeAppointment.values.cron !== null ||
                activeAppointment.values.cron !== undefined),
            DateTime.fromJSDate(activeAppointment.values.startDate).toISO(),
          )
      }
    } else {
      res.successful = true
    }

    if (res.successful) {
      if (!skip) {
        toast.current.show({
          severity: "success",
          detail: "Successfully cancelled appointment",
          life: 3000,
        })
      }
      setAvailableAppointments([])
      setClaimedAppointments([])
      setRecurringOrgControllers([])
      setRecurringStaffControllers([])
      setUpcomingAppointments([])
      setPastAppointments([])
      await getAvailableAppointments()
      await getAppointments()
      await getStaffAppointments()
      setIsOpen(false)
      activeAppointment.resetForm()
    } else {
      toast.current.show({
        severity: "error",
        detail: "Error cancelling appointment",
        life: 3000,
      })
    }
  }

  async function deleteAvail(id) {
    let res = await deleteAvailability(
      userCtx.tokens.getAppointmentsToken(),
      id,
    )

    if (res.successful) {
      loadAvailabilities()
    }
  }

  async function submitNewAppointment(toggleConfirmed = false) {
    const isOrgAppt = +activeMainIndex.code === 1
    let selectedUser = {
      organization_id: userCtx.session.user.organization_id,
      organization_alias: userCtx.session.user.organization_alias,
      staff_id: userCtx.session.user.staff_id,
      staff_alias: userCtx.session.user.staff_alias,
      staff_name_first: userCtx.session.user.staff_name_first,
      staff_name_last: userCtx.session.user.staff_name_last,
      staff_email_address: userCtx.session.user.staff_email_address,
    }
    if (+activeMainIndex.code === 2) {
      selectedUser = selectedStaffContext
      if (
        toggleConfirmed === false &&
        selectedUser.staff_id !== userCtx.session.user.staff_id
      ) {
        setConfirming({
          mode: "behalfedAppointment",
          message:
            "Are you sure you want to schedule this appointment for " +
            selectedUser.optionName +
            "?",
        })
        setConfirmIsOpen(true)
        return
      } else {
        setConfirmIsOpen(false)
      }
    }
    let cron = activeAppointment.values.isRecurringController
      ? activeCron.cronValue
      : null

    let cronPeriod = activeAppointment.values.isRecurringController
      ? activeCron.period
      : null

    let payload = reformatAppointment(
      activeAppointment,
      selectedUser,
      null,
      false,
      apptModalMode.includes("Edit"),
      activeAppointment.values.isRecurringController,
      editingRulesForController,
      +activeMainIndex.code === 1,
      cron,
      toast,
      cronPeriod,
    )

    if (payload) {
      try {
        let res

        if (isOrgAppt) {
          if (activeAppointment.values.id !== 0) {
            let appointmentInstance = undefined

            if (activeAppointment.values.isRecurringController) {
              appointmentInstance = recurringOrgControllers.find(
                (x) => x.id === activeAppointment.values.id,
              )
            } else {
              appointmentInstance = availableAppointments.find(
                (x) => x.id === activeAppointment.values.id,
              )
            }

            res = await editOrgAppointment(
              userCtx.tokens.getAppointmentsToken(),
              payload,
              appointmentInstance?.startDateTime,
            )
          } else
            res = await createNewOrgAppointment(
              userCtx.tokens.getAppointmentsToken(),
              payload,
            )
        } else {
          if (activeAppointment.values.id !== 0) {
            res = await updateAppointment(
              userCtx.tokens.getAppointmentsToken(),
              activeAppointment.values.id,
              payload,
            )
          } else {
            payload.appointmentDetails.metadata.fromBehalfOf = `${_.unescape(
              userCtx.session.user.staff_name_first,
            )} ${_.unescape(userCtx.session.user.staff_name_last)}`
            payload.appointmentDetails.metadata.fromBehalfOfId =
              userCtx.session.user.staff_id
            res = await createNewAppointment(
              userCtx.tokens.getAppointmentsToken(),
              payload,
            )
          }
        }

        if (res.successful) {
          toast.current.show({
            severity: "success",
            detail: `Successfully scheduled ${
              isOrgAppt ? "organization" : ""
            } appointment`,
            life: 3000,
          })
          setIsOpen(false)
          activeAppointment.resetForm()

          refresh()
        } else {
          LogError("API Unable to update appointment", res)
          toast.current.show({
            severity: "error",
            detail: res.error,
            life: 9000,
          })
        }
      } catch (e) {
        LogError("Unable to update appointment", e)
        toast.current.show({
          severity: "error",
          detail: e.message,
          life: 9000,
        })
      }
    }
  }

  async function acceptParticipantAppt(rowData) {
    const userValues = {
      organization_id: userCtx.session.user.organization_id,
      organization_alias: userCtx.session.user.organization_alias,
      staff_id: userCtx.session.user.staff_id,
      staff_alias: userCtx.session.user.staff_alias,
      staff_name_first: userCtx.session.user.staff_name_first,
      staff_name_last: userCtx.session.user.staff_name_last,
      staff_email_address: userCtx.session.user.staff_email_address,
    }

    //there is no modal for confirmation, thats participant side
    let payload = acceptRequestedSchedule(
      rowData,
      userValues,
      participants,
      toast,
    )

    try {
      let res
      const appointmentId = rowData.appointmentId

      if (rowData.type === "RESCHEDULE") {
        // This is a reschedule request
        let editPayload = {
          serviceName: payload.appointmentDetails.serviceName,
          startDateTime: payload.appointmentDetails.startDateTime,
          cron: rowData.cron,
          editingRecurringController: rowData.isRecurring,
          changingRules: rowData.isRecurring,
          recurringDuration: getDate(
            payload.appointmentDetails.endDateTime,
          ).diff(getDate(payload.appointmentDetails.startDateTime), ["minutes"])
            .minutes,
          endDateTime: payload.appointmentDetails.endDateTime,
          metadata: payload.appointmentDetails.metadata,
          alias: {
            orgAlias: userCtx.session.user.organization_id,
            staffAlias: userCtx.session.user.staff_id,
            participantAlias: activeAppointment.values.participant?.alias,
          },
          timezoneName: rowData.timezone,
        }

        // Check for recurring appointment and add appointmentRequest details
        let cancelledDate = ""
        if (appointmentId.includes("recurring_")) {
          let appointmentDetails = {
            orgId: userCtx.session.user.organization_alias,
            participantEmail: rowData.caseEmail,
            participantName: rowData.participantName,
            participantPhone: rowData.casePhone,
            bookedBy: userCtx.session.user.staff_email_address,
            startDateTime: payload.appointmentDetails.startDateTime,
            endDateTime: payload.appointmentDetails.endDateTime,
            serviceName: payload.appointmentDetails.serviceName,
            staffId: userCtx.session.user.staff_alias,
            timezoneName: rowData.timezone,
            //metadata: payload.appointmentDetails.metadata,
          }
          editPayload.appointmentRequest = appointmentDetails

          if (!rowData.isRecurring) {
            // Only applicable to single future instances of a recurring controller
            // Set cancelled date to the original appointment date
            cancelledDate = getDate(rowData.recurringStartDate).valueOf()
          }
        }

        res = await updateAppointment(
          userCtx.tokens.getAppointmentsToken(),
          appointmentId,
          editPayload,
          cancelledDate,
        )
      } else if (rowData.type === "CANCELLING") {
        res = await cancelAppointment(
          userCtx.tokens.getAppointmentsToken(),
          rowData.appointmentId,
          getDate(rowData.startDateTime).valueOf(),
          rowData.isRecurring,
        )
        await cancelAppt(true)
      } else {
        res = await createNewAppointment(
          userCtx.tokens.getAppointmentsToken(),
          payload,
        )
      }

      if (res.successful) {
        await declineParticipantAppointment(
          userCtx.tokens.getAppointmentsToken(),
          rowData.id,
          rowData.type !== "CANCELLING",
          rowData.type === "CANCELLING",
        )

        if (rowData.type === "CANCELLING") {
          toast.current.show({
            severity: "success",
            detail: `Successfully cancelled appointment`,
            life: 3000,
          })
        } else {
          toast.current.show({
            severity: "success",
            detail: `Successfully scheduled accepted appointment`,
            life: 3000,
          })
        }

        refresh()
      } else {
        userCtx.setNotificationError(
          `Unable to accept appointment request ${
            !!res?.error ? ": " + res.error : ""
          }`,
        )
      }
    } catch (error) {
      LogError("An error occurred while accepting the appointment", error)

      toast.current.show({
        severity: "error",
        detail: `An error occurred while accepting the appointment: ${error.message}`,
        life: 9000,
      })

      throw error
    }
  }

  const { refetch } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    skip: true,
    variables: {
      staff_id: uid,
      organization_id,
    },
    onError: (e) => {
      LogError("Unable to retrieve user information", e)
    },
    onCompleted: (data) => {
      return true
    },
  })

  const [loadSoarSessionTemplates] = useLazyQuery(GET_SERVICES, {
    fetchPolicy: "network-only",
    skip: true,
    variables: {
      organization_id,
      template_type: "session_module",
    },
  })

  const formatOrgCalActions = (rowData) => {
    if (+activeOrgCalendarIndex === 4) {
      return (
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          <button
            type="submit"
            className="btn-sm"
            style={{ marginRight: "5px" }}
            onClick={() => openEditModal(rowData)}
          >
            Edit
          </button>
          <button
            type="submit"
            className="btn-sm btn-info"
            style={{ background: "#00508e" }}
            onClick={async () => {
              await deleteOrgController(
                userCtx.tokens.getAppointmentsToken(),
                rowData.id,
              )
              cancelAppt(true)
            }}
          >
            Delete
          </button>
        </div>
      )
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          <button
            type="submit"
            className="btn-sm btn-info"
            style={{ background: "#00508e", marginRight: "5px" }}
            onClick={() =>
              toggleConfirmOrgClaim(
                rowData.id,
                rowData.cron !== null && rowData.cron !== undefined,
                rowData.startDateTime,
                rowData.endDateTime,
                rowData.caseId,
              )
            }
          >
            Accept
          </button>
          <button
            type="submit"
            className="btn-sm"
            onClick={() => openEditModal(rowData)}
          >
            Edit
          </button>
        </div>
      )
    }
  }

  async function saveAvailability() {
    let cron
    if (activeAvailability.values.isRecurring) {
      if (availModalMode.includes("Edit")) {
        cron = $(createAvailabilityCron.current)
          .data("cronBuilder")
          .getExpression("create", activeAvailability.values.startTime)
          .replace("?", "*")
      } else if (availModalMode.includes("Set")) {
        cron = $(createAvailabilityCron.current)
          .data("cronBuilder")
          .getExpression("create", activeAvailability.values.startTime)
          .replace("?", "*")
      }
    }

    let payload = reformatAvailability(
      activeAvailability,
      selectedStaffContext,
      null,
      false,
      false,
      activeAvailability.values.isRecurring,
      editingRulesForAvailController,
      cron,
      toast,
    )

    if (
      getDate(payload.startDate).toUnixInteger() <
        DateTime.local().toUnixInteger() &&
      !payload.isRecurring
    ) {
      toast.current.show({
        severity: "error",
        detail: "You cannot set an availability in the past",
        life: 9000,
      })
      return
    }

    payload.fromBehalfOf = `${_.unescape(
      userCtx.session.user.staff_name_first,
    )} ${_.unescape(userCtx.session.user.staff_name_last)}`
    payload.fromBehalfOfId = userCtx.session.user.staff_id

    let res
    if (availModalMode.includes("Set")) {
      res = await setAvailability(
        userCtx.tokens.getAppointmentsToken(),
        payload,
      )
    } else {
      res = await editAvailability(
        userCtx.tokens.getAppointmentsToken(),
        payload,
      )
    }

    if (res.successful) {
      setAvailabilityIsOpen(false)
      activeAvailability.resetForm()
      toast.current.show({
        severity: "success",
        detail: `Successfully set availability`,
        life: 3000,
      })
      await loadAvailabilities()
    } else {
      toast.current.show({
        severity: "error",
        detail: res.error,
        life: 9000,
      })
    }
  }

  const formatAvailActions = (rowData) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <button
          type="submit"
          className="btn-sm btn-info"
          style={{ background: "#00508e", marginRight: "5px" }}
          onClick={() => {
            openEditAvailModal(rowData)
          }}
        >
          Edit
        </button>
        <button
          type="submit"
          className="btn-sm btn-danger"
          onClick={() => deleteAvail(rowData.id)}
        >
          Delete
        </button>
      </div>
    )
  }

  function openApptModal(mode) {
    setIsOpen(true)

    const defaultStartDate = DateTime.fromJSDate(date)

    setActiveCron({
      cronValue: `${defaultStartDate.minute} ${defaultStartDate.hour} * * *`,
      cronDescription: "",
      period: "Daily",
    })
    activeAppointment.resetForm()
    if (+activeMainIndex.code === 0)
      activeAppointment.setFieldValue("startDate", date)
    else {
      activeAppointment.setFieldValue("startDate", null)
      activeAppointment.setFieldValue("startTime", null)
    }
    setApptModalMode(mode)
  }

  function renderFooter() {
    if (+activeStaffCalendarIndex === 1 && +activeMainIndex.code === 2) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "10px",
          }}
        >
          <button
            type="submit"
            className="btn"
            onClick={() => {
              setAvailabilityIsOpen(true)
              activeAvailability.resetForm()
              setAvailModalMode("Set Availability")
            }}
          >
            Set Availability
          </button>
        </div>
      )
    } else if (+activeMainIndex.code === 1) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "10px",
          }}
        >
          <button
            type="submit"
            className="btn"
            onClick={() => {
              openApptModal("Submit Organization Appointment")
            }}
          >
            Schedule New Organization Appointment
          </button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "10px",
          }}
        >
          <button
            type="submit"
            className="btn"
            onClick={() => {
              openApptModal("Submit Appointment")
            }}
            disabled={
              isLoadingParticipantLink ||
              isLoadingAppointments ||
              isLoadingStaffAppointments
            }
          >
            Schedule New Appointment
          </button>
          {/*<button type="submit" className="btn">
                    Update Calendar Details
        </button>*/}
        </div>
      )
    }
  }

  function toggleRecurringAvail() {
    if (!activeAvailability.values.isRecurring) {
      return (
        <>
          <div style={{ ...customStyles.inputField, width: "95%" }}>
            <label htmlFor="availableDate">Available Date</label>
            <br />
            <Calendar
              id="availableDate"
              style={customStyles.inputStyle}
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.availableDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAvailability, "startDate"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">Start Time</label>
            <br />
            <Calendar
              id="startTime"
              style={customStyles.inputStyle}
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.startTime}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAvailability, "startTime"),
              })}
              timeOnly
              hourFormat="12"
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">End Time</label>
            <br />
            <Calendar
              id="endTime"
              style={customStyles.inputStyle}
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.endTime}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAvailability, "startTime"),
              })}
              timeOnly
              hourFormat="12"
            />
          </div>
        </>
      )
    } else {
      return (
        <>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Start Date</label>
            <br />
            <Calendar
              id="startDate"
              style={customStyles.inputStyle}
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.startDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAvailability, "startDate"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">End Date</label>
            <br />
            <Calendar
              id="endDate"
              style={customStyles.inputStyle}
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.endDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAvailability, "endDate"),
              })}
            />
          </div>
          <div style={{ ...customStyles.inputField, width: "95%" }}>
            <div
              hidden={
                availModalMode.includes("Edit") &&
                !editingRulesForAvailController
              }
            >
              <br></br>
              <div ref={createAvailabilityCron}></div>
              <br />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ ...customStyles.inputField }}>
                  <label htmlFor="startTime">Start Time</label>
                  <br />
                  <Calendar
                    id="startTime"
                    style={customStyles.inputStyle}
                    onChange={activeAvailability.handleChange}
                    value={activeAvailability.values.startTime}
                    className={classNames({
                      "p-invalid": isFormFieldValid(
                        activeAvailability,
                        "startTime",
                      ),
                    })}
                    timeOnly
                    hourFormat="12"
                  />
                </div>
                <div style={customStyles.inputField}>
                  <label htmlFor="endtime">End Time</label>
                  <br />
                  <Calendar
                    id="endTime"
                    style={customStyles.inputStyle}
                    onChange={activeAvailability.handleChange}
                    value={activeAvailability.values.endTime}
                    className={classNames({
                      "p-invalid": isFormFieldValid(
                        activeAvailability,
                        "endTime",
                      ),
                    })}
                    timeOnly
                    hourFormat="12"
                  />
                </div>
              </div>
            </div>
            <div
              hidden={
                availModalMode.includes("Set") || editingRulesForAvailController
              }
            >
              <div style={{ ...customStyles.inputField, width: "95%" }}>
                <label htmlFor="">Recurring Rules:</label>
                <br />
                <span>{activeAvailability.values.cronDescription}</span> |{" "}
                <button
                  type="button"
                  className="btn-sm"
                  onClick={() => setEditingRulesForAvailController(true)}
                >
                  Change
                </button>
                <br />
              </div>
            </div>
          </div>
        </>
      )
    }
  }

  async function deleteRequest(id) {
    try {
      let res = await declineParticipantAppointment(
        userCtx.tokens.getAppointmentsToken(),
        id,
        false,
      )

      if (res.successful) {
        toast.current.show({
          severity: "success",
          detail: `This appointment request has been denied.`,
          life: 3000,
        })

        setPendingAppointments([])
        await getPendingAppointments()
      } else {
        userCtx.setNotificationError(
          "An error occurred while declining the appointment",
        )
        LogError("An error occurred while declining the appointment", res)
      }
    } catch (error) {
      userCtx.setNotificationError(
        "An error occurred while declining the appointment",
      )
      LogError("An error occurred while declining the appointment", error)
    }
  }

  const formatPendingActions = (rowData) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <button
          type="submit"
          className="btn-sm btn-info"
          style={{ background: "#00508e", marginRight: "5px" }}
          onClick={() => acceptParticipantAppt(rowData)}
        >
          Accept
        </button>
        <button
          type="submit"
          className="btn-sm btn-danger"
          onClick={() => deleteRequest(rowData.id)}
        >
          Deny
        </button>
      </div>
    )
  }
  function toggleRecurringAppt() {
    //Get the recurring startTime in the specified timezone
    const workingStartTimeInZone = activeAppointment.values.startTime
      ? DateTime.fromJSDate(activeAppointment.values.startTime).setZone(
          activeAppointment.values.timezone.code,
        )
      : null

    //Set the time to the TZ time in local to display correct time in calendar
    const workingStartTime = workingStartTimeInZone
      ? DateTime.fromJSDate(activeAppointment.values.startTime)
          .set({
            hour: workingStartTimeInZone.hour,
            minute: workingStartTimeInZone.minute,
            second: 0,
            millisecond: 0,
          })
          .toJSDate()
      : null

    const handleStartTimeUpdate = (e) => {
      const newStartTime = DateTime.fromJSDate(e.value).setZone(
        activeAppointment.values.timezone.code,
        {
          keepLocalTime: true,
        },
      )

      const changeEvent = { ...e, value: newStartTime.toJSDate() }
      changeEvent.target.value = newStartTime.toJSDate()

      activeAppointment.handleChange(changeEvent)
    }

    if (!activeAppointment.values.isRecurringController) {
      return (
        <>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Appointment Date</label>
            <br />
            <Calendar
              id="startDate"
              style={customStyles.inputStyle}
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.startDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "startDate"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">Appointment Time</label>
            <br />
            <Calendar
              id="startTime"
              style={customStyles.inputStyle}
              onChange={handleStartTimeUpdate}
              value={workingStartTime}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "startTime"),
              })}
              timeOnly
              hourFormat="12"
            />
          </div>
        </>
      )
    } else {
      return (
        <>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Start Date</label>
            <br />
            <Calendar
              id="startDate"
              style={customStyles.inputStyle}
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.startDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "startDate"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">End Date</label>
            <br />
            <Calendar
              id="endDate"
              style={customStyles.inputStyle}
              onChange={(e) => {
                activeAppointment.handleChange(e)
              }}
              value={activeAppointment.values.endDate}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "endDate"),
              })}
            />
          </div>
          <div style={{ ...customStyles.inputField, width: "95%" }}>
            <div
              hidden={
                apptModalMode.includes("Edit") && !editingRulesForController
              }
            >
              <AppointmentsFormCron
                cronValues={activeCron}
                startTime={activeAppointment?.values?.startTime}
                startTimeTimezoneCode={
                  activeAppointment?.values?.timezone?.code
                }
                onChangeCronValues={(cron) => {
                  setActiveCron(cron)
                }}
              />
              <br />
              <div style={{ ...customStyles.inputField, width: "100%" }}>
                <label htmlFor="startTime">Start Time</label>
                <br />
                <Calendar
                  id="startTime"
                  style={customStyles.inputStyle}
                  onChange={handleStartTimeUpdate}
                  value={workingStartTime}
                  className={classNames({
                    "p-invalid": isFormFieldValid(
                      activeAppointment,
                      "startTime",
                    ),
                  })}
                  timeOnly
                  hourFormat="12"
                />
              </div>
            </div>
            <div
              hidden={
                apptModalMode.includes("Submit") ||
                editingRulesForController ||
                activeAppointment.values.isRecurringController === false
              }
            >
              <div style={{ ...customStyles.inputField, width: "95%" }}>
                <label htmlFor="">Recurring Rules:</label>
                <br />
                <span>
                  {activeAppointment.values.cronDescriptionActual}
                </span> |{" "}
                <button
                  type="button"
                  className="btn-sm"
                  onClick={() => setEditingRulesForController(true)}
                >
                  Change
                </button>
                <br />
              </div>
            </div>
          </div>
        </>
      )
    }
  }

  useEffect(() => {
    if (
      appointments.appointments !== undefined &&
      cached_appointments.appointments !== undefined
    )
      filterAppointments()
  }, [selectedFilters, date2])

  function filterAppointments(
    orgCalContext = activeOrgCalendarContext,
    staffCalContext = activeStaffCalendarContext,
  ) {
    const isCalendarViewActive = checkCalendarView()
    const getFilteredList = (list, isRecurring, ignoreDateFilter) => {
      return applyAppointmentFilters(
        list,
        selectedFilters,
        services,
        date2,
        ignoreDateFilter || isCalendarViewActive,
        isRecurring,
      )
    }

    const filteredAppointments = {
      ...cached_appointments,
      appointments: getFilteredList(cached_appointments.appointments),
    }
    setAppointments(filteredAppointments)

    const filteredRecurringAppointments = getFilteredList(
      cached_recurringAppointments,
      true,
    )
    setRecurringAppointments(filteredRecurringAppointments)

    const filteredAvailableAppointments = getFilteredList(
      cached_availableAppointments,
    )

    setAvailableAppointments(filteredAvailableAppointments)

    const filteredClaimedAppointments = getFilteredList(
      cached_claimedAppointments,
    )
    setClaimedAppointments(filteredClaimedAppointments)

    const filteredUnclaimedAppointment = getFilteredList(
      cached_unclaimedAppointments,
    )
    setUnclaimedAppointments(filteredUnclaimedAppointment)

    const filteredPastAppointments = getFilteredList(
      cached_pastAppointments,
      false,
      true,
    )
    setPastAppointments(filteredPastAppointments)

    const filteredUpcomingAppointments = getFilteredList(
      cached_upcomingAppointments,
    )
    setUpcomingAppointments(filteredUpcomingAppointments)

    const filteredPendingAppointments = getFilteredList(
      cached_pendingAppointments,
    )
    setPendingAppointments(filteredPendingAppointments)
    const filteredRecurringOrganizationControllers = getFilteredList(
      cached_recurringOrgControllers,
      true,
    )
    setRecurringOrgControllers(filteredRecurringOrganizationControllers)

    if (orgCalContext) {
      switch (orgCalContext) {
        case "Available Appointments":
          setActiveOrgCalendarArray(filteredAvailableAppointments)
          break
        case "Claimed Appointments":
          setActiveOrgCalendarArray(filteredClaimedAppointments)
          break
        case "Unclaimed Appointments":
          setActiveOrgCalendarArray(filteredUnclaimedAppointment)
          break
        case "Declined Appointments":
          setActiveOrgCalendarArray(
            filteredPendingAppointments.filter(
              (x) => x.type === "DECLINED" || x.type === "CANCELLED.DENIED",
            ),
          )
          break
        default:
          setActiveOrgCalendarArray([])
      }

      setActiveOrgCalendarContext(orgCalContext)
    }

    if (staffCalContext) {
      switch (staffCalContext) {
        case "Pending Appointments":
          setActiveStaffCalendarArray(
            filteredPendingAppointments.filter(
              (x) =>
                x.type !== "DECLINED" &&
                x.type !== "BOOKED" &&
                x.type !== "CANCELLED",
            ),
          )
          break
        case "Past Appointments":
          setActiveStaffCalendarArray(filteredPastAppointments)
          break
        case "Upcoming Appointments":
          setActiveStaffCalendarArray(filteredUpcomingAppointments)
          break
        case "Declined Appointments":
          setActiveStaffCalendarArray(
            filteredPendingAppointments.filter(
              (x) => x.type === "DECLINED" || x.type === "CANCELLED.DENIED",
            ),
          )
          break
        default:
          setActiveStaffCalendarArray([])
      }
      setActiveStaffCalendarContext(staffCalContext)
    }
  }

  async function confirmAction() {
    if (confirming.mode === "availableAppointment") acceptAvailableAppointment()
    else if (confirming.mode === "behalfedAppointment")
      submitNewAppointment(true)
    else if (confirming.mode == "cancelAppointment") {
      if (
        activeAppointment.values.isRecurringController &&
        activeMainIndex.code == 1
      ) {
        await deleteOrgController(
          userCtx.tokens.getAppointmentsToken(),
          activeAppointment.values.id,
        )
        cancelAppt(true, true)
      } else cancelAppt(false, true)
    }
  }

  async function updateList(newDate) {
    setDate(newDate)
    let filtered = {
      appointments: appointments.appointments.filter((x) => {
        let startUnix = DateTime.fromFormat(
          x.startDateTime,
          getDateKey(x.startDateTime),
        ).toUnixInteger()
        let selectedUnix = DateTime.fromJSDate(newDate).toUnixInteger()

        return (
          startUnix > selectedUnix &&
          startUnix <
            DateTime.fromJSDate(newDate).plus({ days: 1 }).toUnixInteger()
        )
      }),
    }
    setData(filtered)
    activeAppointment.setFieldValue("startDate", newDate)
  }

  function checkCalendarView() {
    if (+activeMainIndex.code === 0) {
      return isCalendarView.myCalendar
    } else if (+activeMainIndex.code === 1) {
      return isCalendarView.orgCalendar
    } else {
      return isCalendarView.staffCalendar
    }
  }

  function setCalendarView(value) {
    if (+activeMainIndex.code === 0) {
      setIsCalendarView({ ...isCalendarView, myCalendar: value })
    } else if (+activeMainIndex.code === 1) {
      setIsCalendarView({ ...isCalendarView, orgCalendar: value })
    } else {
      setIsCalendarView({ ...isCalendarView, staffCalendar: value })
    }

    if (value) {
      setSelectedDateViewValue(DateTime.now().startOf("month").toJSDate())
    } else {
      // If no date range is selected, set to defaults
      let currentDateView = getInitializedSelectedDateView()

      const from = DateTime.fromJSDate(currentDateView.from).plus({
        days: -30,
      })
      const to = DateTime.fromJSDate(currentDateView.to).plus({
        days: 30,
      })

      setSelectedDateViewValue(from.toJSDate(), to.toJSDate())
    }
  }

  function GetParticipantLink({
    participant_name,
    participant_id,
    participant_alias,
  }) {
    return (
      <span
        style={{ color: "#8C28E4" }}
        onClick={async () => {
          setIsLoadingParticipantLink(true)
          if (participant_id) {
            await userCtx.changeParticipant(participant_id)
            navigate(ROUTES.PARTICIPANT_PROFILE, {
              replace: true,
            })
            setShow(false)
            setIsLoadingParticipantLink(false)
          } else if (participant_alias) {
            setIsLoadingParticipantLink(true)
            userCtx.setParticipantByAliasID(participant_alias).then(() => {
              navigate(ROUTES.PARTICIPANT_PROFILE, {
                replace: true,
              })
              setShow(false)
              setIsLoadingParticipantLink(false)
            })
          } else {
            console.error("Unknown participant id or alias")
            userCtx.setNotificationError("Unable to find the participant id")
            setIsLoadingParticipantLink(false)
          }
        }}
      >
        {participant_name}
      </span>
    )
  }

  function ParticipantColumnBody(rowData) {
    if (!rowData.participantName) {
      return (
        <GetParticipantLink
          participant_name={rowData.firstName + rowData.lastName}
          participant_alias={rowData.caseId}
        />
      )
    } else {
      return (
        <GetParticipantLink
          participant_name={rowData.participantName}
          participant_id={rowData.caseUserId}
          participant_alias={rowData.caseId}
        />
      )
    }
  }

  function EditAppointmentsColumnBody(rowData) {
    const onClick = () => {
      openEditModal(rowData)
    }
    return (
      <button
        className="btn"
        onClick={onClick}
        style={{ width: "50px", paddingLeft: "12px" }}
      >
        Edit
      </button>
    )
  }

  function EditRecurringAppointmentsColumnBody(rowData) {
    const onClick = () => {
      const controller = recurringAppointments.filter(
        (x) => x.recurringControllerId.toString() === rowData.id.toString(),
      )
      if (controller.length > 0) {
        openEditModal(controller[0])
      } else {
        userCtx.setNotificationError(
          "Unable to find the recurring appointment controller for this instance",
        )
      }
    }

    return (
      <button
        className="btn"
        onClick={onClick}
        style={{ width: "50px", paddingLeft: "12px" }}
      >
        Edit
      </button>
    )
  }

  return (
    <>
      <li
        className="top-icon"
        onClick={() =>
          userCtx.setToggleAppointments({
            toggle: true,
            page: "default",
          })
        }
      >
        <span className="material-icons top-icon-span">calendar_month</span>
        <label className="top-menu-label">Calendar</label>
      </li>

      <Toast ref={toast} position="top-right" />

      {/* Main Appointments Dialog */}
      <Dialog
        header={() => (
          <div style={{ paddingLeft: "10px" }}>
            <h4
              style={{
                margin: 0,
                marginBottom: "15px",
                color: "#757575",
                fontSize: "20px",
              }}
            >
              Calendars
            </h4>
          </div>
        )}
        visible={show}
        onHide={() => {
          setShow(false)
        }}
        style={{ width: "1150px", height: "1000px" }}
        contentStyle={{ padding: 0 }}
        headerStyle={{ paddingBottom: "0px" }}
        footer={renderFooter}
      >
        {isLoadingParticipantLink ? (
          <div
            style={{
              width: "100%",
              minHeight: "20vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ProgressSpinner style={{ top: "230px" }} />
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                alignItems: "baseline",
              }}
            >
              <Dropdown
                onChange={(ev) => {
                  //If the selection is My Calendar and the active user is not me, set it to me.
                  if (
                    ev.value.code === 0 &&
                    selectedStaffContext.staff_alias !==
                      userCtx.session.user.staff_alias
                  ) {
                    setSelectedStaffContext(
                      users.find((x) => x.id === userCtx.session.user.staff_id),
                    )
                  }
                  setActiveMainIndex(ev.value)
                  setCalendarView(true)
                }}
                value={activeMainIndex}
                options={mainViews}
                optionLabel="name"
                disabled={isLoadingAppointments || isLoadingStaffAppointments}
              />
              <ToggleButton
                onLabel="Calendar View"
                offLabel="List View"
                onIcon="pi pi-calendar"
                offIcon="pi pi-align-justify"
                checked={checkCalendarView()}
                onChange={(e) => setCalendarView(e.value)}
              />
              <div
                hidden={
                  !isCalendarView.orgCalendar ||
                  +activeMainIndex.code === 0 ||
                  +activeMainIndex.code === 2
                }
              >
                <div hidden={+activeMainIndex.code !== 1}>
                  <Dropdown
                    onChange={(ev) => filterAppointments(ev.value, null)}
                    value={activeOrgCalendarContext}
                    options={orgCalListViewOptions}
                  />
                </div>
              </div>
              <div
                hidden={
                  !isCalendarView.staffCalendar ||
                  +activeMainIndex.code === 0 ||
                  +activeMainIndex.code === 1
                }
              >
                <div hidden={+activeMainIndex.code !== 2}>
                  <Dropdown
                    onChange={(ev) => filterAppointments(null, ev.value)}
                    value={activeStaffCalendarContext}
                    options={staffCalListViewOptions}
                  />
                </div>
              </div>
              <div hidden={checkCalendarView()} style={{ width: "22%" }}>
                <Calendar
                  id="range"
                  style={{ width: "100%" }}
                  value={date2}
                  onChange={(e) => {
                    setDate2(e.value)

                    if (!e.value.includes(null)) {
                      setSelectedDateViewValue(e.value[0], e.value[1])
                    }
                  }}
                  selectionMode="range"
                  readOnlyInput
                  placeholder="Date Range"
                />
              </div>
              <MultiSelect
                style={{ width: "30%" }}
                display="chip"
                value={selectedFilters}
                options={groupedFilters}
                onChange={(e) => setSelectedFilters(e.value)}
                optionLabel="label"
                optionGroupLabel="label"
                optionGroupChildren="items"
                placeholder="Filters"
              />
            </div>
            <div style={{ padding: "15px" }}>
              <div hidden={+activeMainIndex.code !== 0}>
                <div hidden={!isCalendarView.myCalendar}>
                  <Calendar
                    inline
                    value={date}
                    viewDate={selectedDateView?.from}
                    onViewDateChange={(ev) =>
                      setSelectedDateViewValue(ev.value)
                    }
                    onChange={(e) => updateList(e.value)}
                    style={{
                      marginTop: "5px",
                      width: "100%",
                      pDatepickerCurrentDay: { background: "red" },
                    }}
                  ></Calendar>
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        border: "2px solid #8C28E4",
                        borderRight: 0,
                        borderBottomLeftRadius: "2px",
                        width: "30%",
                        height: "300px",
                        padding: "10px 30px 30px 30px",
                        fontFamily: "Lato",
                        overflow: "auto",
                      }}
                    >
                      <h3>Recurring Controllers</h3>
                      <br />
                      {recurringAppointments.map((obj, i) => {
                        return (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "20px",
                            }}
                          >
                            <div className="">
                              <b style={{ color: "#666666" }}>
                                {obj.recurringController.cronDescription}
                              </b>
                              <br />
                              <span style={{ color: "#666666" }}>
                                {" with "}
                              </span>
                              <GetParticipantLink
                                participant_name={`${obj.recurringController.firstName} ${obj.recurringController.lastName}`}
                                participant_alias={
                                  obj.recurringController.caseId
                                }
                                appt={obj}
                              />
                            </div>

                            <button
                              type="submit"
                              className="btn-sm"
                              style={{
                                height: "fit-content",
                              }}
                              onClick={() => openEditModal(obj)}
                            >
                              Edit
                            </button>
                          </div>
                        )
                      })}
                    </div>
                    <div
                      style={{
                        border: "2px solid #8C28E4",
                        width: "70%",
                        borderBottomRightRadius: "12px",
                        height: "300px",
                        padding: "10px 30px 30px 30px",
                        fontFamily: "Lato",
                        overflow: "auto",
                      }}
                    >
                      <h3>Appointments</h3>
                      <br />
                      {data.appointments
                        .filter((x) => {
                          let startUnix = DateTime.fromFormat(
                            x.startDateTime,
                            getDateKey(x.startDateTime),
                          ).toUnixInteger()
                          let selectedUnix =
                            DateTime.fromJSDate(date).toUnixInteger()
                          return (
                            startUnix > selectedUnix &&
                            startUnix <
                              DateTime.fromJSDate(date)
                                .plus({ days: 1 })
                                .toUnixInteger()
                          )
                        })
                        .map((obj, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "20px",
                              }}
                            >
                              <div className="">
                                <b style={{ color: "#666666" }}>
                                  {DateTime.fromFormat(
                                    obj.startDateTime,
                                    getDateKey(obj.startDateTime),
                                    { zone: obj.timezoneName || obj.timezone },
                                  )
                                    .setZone(DateTime.local().toFormat("z"))
                                    .toFormat("h:mm a")}
                                </b>
                                <br />
                                <span style={{ color: "#666666" }}>
                                  {" "}
                                  {obj.serviceName + " with "}
                                </span>
                                <GetParticipantLink
                                  participant_name={obj.participantName}
                                  participant_id={extractSoarId(obj)}
                                  appt={obj}
                                />
                              </div>

                              <button
                                type="submit"
                                className="btn-sm"
                                style={{ display: "block" }}
                                onClick={() => openEditModal(obj)}
                              >
                                Edit Appointment
                              </button>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </div>
                <div hidden={isCalendarView.myCalendar}>
                  <TabView
                    activeIndex={activeStaffSchedulingIndex}
                    onTabChange={(e) => setActiveStaffSchedulingIndex(e.index)}
                    panelContainerStyle={{
                      background: "rgba(0,0,0,0)",
                      padding: 0,
                    }}
                  >
                    <TabPanel header="Pending Appointments">
                      <AppointmentsTablePending
                        pendingAppointments={pendingAppointments.filter(
                          (x) =>
                            x.type !== "DECLINED" &&
                            x.type !== "BOOKED" &&
                            x.type !== "CANCELLED" &&
                            x.type !== "CANCELLED.DENIED",
                        )}
                        getParticipantColumnBody={ParticipantColumnBody}
                        getPendingActionsColumnBody={formatPendingActions}
                      />
                    </TabPanel>
                    <TabPanel header="Past Appointments">
                      <DataTable
                        value={pastAppointments}
                        sortField="startDateTime"
                        sortOrder={1}
                      >
                        <Column
                          field="startDateTime"
                          sortable
                          header="Date"
                          body={formatOrgCalDate}
                        />
                        <Column
                          field="engagementType"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          field="scheduledTime"
                          sortable
                          header="Scheduled Time"
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="fromBehalfOf"
                          sortable
                          header="Staff Assigner"
                        />
                      </DataTable>
                    </TabPanel>
                    <TabPanel header="Declined Appointments">
                      <AppointmentsTableDeclined
                        declinedAppointments={pendingAppointments.filter(
                          (x) =>
                            x.type === "DECLINED" ||
                            x.type === "CANCELLED.DENIED",
                        )}
                        GetParticipantColumnBody={ParticipantColumnBody}
                      />
                    </TabPanel>
                    <TabPanel header="Upcoming Appointments">
                      <DataTable
                        value={appointments.appointments?.filter(
                          (appointment) =>
                            appointment.startDateTimeActual > Date.now(),
                        )}
                        sortField="startDateTimeActual"
                        sortOrder={1}
                      >
                        <Column
                          field="startDateTimeActual"
                          sortable
                          header="Date"
                          body={formatDateTimeActual}
                        />
                        <Column
                          field="serviceName"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="appointment_engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          field="scheduledTime"
                          sortable
                          header="Scheduled Time"
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="appointment_fromBehalfOf"
                          sortable
                          header="Staff Assigner"
                        />
                        <Column body={EditAppointmentsColumnBody} />
                      </DataTable>
                    </TabPanel>
                    <TabPanel header="Scheduled Recurring Appointments">
                      <DataTable
                        value={recurringAppointments.map((x) => {
                          x.recurringController.timezone =
                            x.timezoneName || x.timezone
                          return x.recurringController
                        })}
                        sortField="startDateTime"
                        sortOrder={1}
                      >
                        <Column
                          field="cronDescription"
                          sortable
                          header="Date"
                        />
                        <Column
                          field="serviceName"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          field="range"
                          sortable
                          header="Range"
                          body={(obj) => {
                            return (
                              getDate(obj.startDate).toFormat("MM/dd/yyyy") +
                              " - " +
                              getDate(obj.endDate).toFormat("MM/dd/yyyy")
                            )
                          }}
                        />
                        <Column
                          field="scheduledTime"
                          sortable
                          header="Scheduled Time"
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="fromBehalfOf"
                          sortable
                          header="Staff Assigner"
                        />
                        <Column body={EditRecurringAppointmentsColumnBody} />
                      </DataTable>
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <div hidden={+activeMainIndex.code !== 1}>
                <div hidden={!isCalendarView.orgCalendar}>
                  <Calendar
                    inline
                    value={date}
                    viewDate={selectedDateView?.from}
                    onViewDateChange={(ev) =>
                      setSelectedDateViewValue(ev.value)
                    }
                    onChange={(e) => updateList(e.value)}
                    style={{
                      marginTop: "5px",
                      width: "100%",
                      pDatepickerCurrentDay: { background: "red" },
                    }}
                  ></Calendar>
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        border: "2px solid #8C28E4",
                        borderRight: 0,
                        borderBottomLeftRadius: "2px",
                        width: "30%",
                        height: "300px",
                        padding: "10px 30px 30px 30px",
                        fontFamily: "Lato",
                        overflow: "auto",
                      }}
                    >
                      <h3>Recurring Controllers</h3>
                      <br />
                      {recurringOrgControllers.map((obj, i) => {
                        return (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "20px",
                            }}
                          >
                            <div className="">
                              <b style={{ color: "#666666" }}>
                                {obj.frequency}
                              </b>
                              <br />
                              <span style={{ color: "#666666" }}>
                                {" with "}
                              </span>
                              <GetParticipantLink
                                participant_name={obj.participantName}
                                participant_id={extractSoarId(obj)}
                                appt={obj}
                              />
                            </div>

                            <button
                              type="submit"
                              className="btn-sm"
                              style={{
                                height: "fit-content",
                              }}
                              onClick={() => openEditModal(obj)}
                            >
                              Edit
                            </button>
                          </div>
                        )
                      })}
                    </div>
                    <div
                      style={{
                        border: "2px solid #8C28E4",
                        width: "70%",
                        borderBottomRightRadius: "12px",
                        height: "300px",
                        padding: "10px 30px 30px 30px",
                        fontFamily: "Lato",
                        overflow: "auto",
                      }}
                    >
                      <h3>Appointments</h3>
                      <br />
                      {activeOrgCalendarArray
                        .filter((x) => {
                          let startUnix = getDate(
                            x.startDateTime,
                          ).toUnixInteger()
                          let selectedUnix =
                            DateTime.fromJSDate(date).toUnixInteger()
                          return (
                            startUnix > selectedUnix &&
                            startUnix <
                              DateTime.fromJSDate(date)
                                .plus({ days: 1 })
                                .toUnixInteger()
                          )
                        })
                        .map((obj, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "20px",
                              }}
                            >
                              <div className="">
                                <b style={{ color: "#666666" }}>
                                  {DateTime.fromISO(
                                    getDate(obj.startDateTime).toISO(),
                                    {
                                      zone: obj.timezoneName || obj.timezone,
                                    },
                                  )
                                    .setZone(DateTime.local().toFormat("z"))
                                    .toFormat("h:mm a")}
                                </b>
                                <br />
                                <span style={{ color: "#666666" }}>
                                  {" "}
                                  {obj.engagementType + " with "}
                                </span>
                                <GetParticipantLink
                                  participant_name={obj.participantName}
                                  participant_alias={obj.caseId}
                                  participant_id={extractSoarId(obj)}
                                  appt={obj}
                                />
                              </div>

                              {activeOrgCalendarContext ===
                              "Available Appointments"
                                ? formatOrgCalActions(obj)
                                : null}
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </div>
                <div hidden={isCalendarView.orgCalendar}>
                  <TabView
                    activeIndex={activeOrgCalendarIndex}
                    onTabChange={(e) => setActiveOrgCalendarIndex(e.index)}
                    panelContainerStyle={{
                      background: "rgba(0,0,0,0)",
                      padding: 0,
                    }}
                  >
                    <TabPanel header="Available Appointments">
                      <DataTable
                        value={availableAppointments}
                        sortField="startDateTimeActual"
                        sortOrder={1}
                      >
                        <Column
                          field="startDateTimeActual"
                          sortable
                          header="Date"
                          body={(rowData) => {
                            return rowData.startDateTimeActual.toFormat(
                              "MM/dd/yyyy",
                            )
                          }}
                        />
                        <Column
                          field="engagementType"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          field="scheduledTime"
                          sortable
                          header="Scheduled Time"
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="requestedBy"
                          sortable
                          header="Staff Assigner"
                        />
                        <Column
                          field="action"
                          header="Action"
                          body={formatOrgCalActions}
                        />
                      </DataTable>
                    </TabPanel>
                    <TabPanel header="Declined Appointments">
                      <AppointmentsTableDeclined
                        declinedAppointments={pendingAppointments.filter(
                          (x) =>
                            x.type === "DECLINED" ||
                            x.type === "CANCELLED.DENIED",
                        )}
                        GetParticipantColumnBody={ParticipantColumnBody}
                      />
                    </TabPanel>
                    <TabPanel header="Claimed Appointments">
                      <DataTable
                        value={claimedAppointments}
                        sortField="startDateTime"
                        sortOrder={1}
                      >
                        <Column
                          field="startDateTime"
                          sortable
                          header="Date"
                          body={formatOrgCalDate}
                        />
                        <Column
                          field="engagementType"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          field="scheduledTime"
                          sortable
                          header="Scheduled Time"
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="requestedBy"
                          sortable
                          header="Staff Assigner"
                        />
                        <Column field="claimedBy" sortable header="Staff" />
                      </DataTable>
                    </TabPanel>
                    <TabPanel header="Unclaimed Appointments">
                      <DataTable
                        value={unclaimedAppointments}
                        sortField="startDateTime"
                        sortOrder={1}
                      >
                        <Column
                          field="startDateTime"
                          sortable
                          header="Date"
                          body={formatOrgCalDate}
                        />
                        <Column
                          field="engagementType"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          field="scheduledTime"
                          sortable
                          header="Scheduled Time"
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="requestedBy"
                          sortable
                          header="Staff Assigner"
                        />
                      </DataTable>
                    </TabPanel>
                    <TabPanel header="Recurring Controllers">
                      <DataTable value={recurringOrgControllers}>
                        <Column
                          field="localCronDescription"
                          sortable
                          header="Date"
                        />
                        <Column
                          field="engagementType"
                          sortable
                          header="Engagement Type"
                        />
                        <Column
                          field="engagementChannel"
                          sortable
                          bodyStyle={{ textTransform: "capitalize" }}
                          header="Engagement Channel"
                        />
                        <Column
                          sortable
                          header="Range"
                          body={(obj) => {
                            return (
                              getDate(obj.startDate).toFormat("MM/dd/yyyy") +
                              " - " +
                              getDate(obj.endDate).toFormat("MM/dd/yyyy")
                            )
                          }}
                        />
                        <Column
                          body={ParticipantColumnBody}
                          field="participantName"
                          sortable
                          header="Participant"
                        />
                        <Column
                          field="requestedBy"
                          sortable
                          header="Staff Assigner"
                        />
                        <Column
                          field="action"
                          header="Action"
                          body={formatOrgCalActions}
                        />
                      </DataTable>
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <div hidden={+activeMainIndex.code !== 2}>
                <div
                  style={{
                    ...customStyles.inputField,
                    width: "100%",
                    margin: "auto",
                  }}
                >
                  <label htmlFor="startDate">Staff</label>
                  <br />
                  <Dropdown
                    value={selectedStaffContext}
                    onChange={(e) => setSelectedStaffContext(e.value)}
                    style={customStyles.inputStyle}
                    options={users}
                    optionLabel="name2"
                    disabled={
                      isLoadingAppointments || isLoadingStaffAppointments
                    }
                  />
                </div>
                {isLoadingAppointments || isLoadingStaffAppointments ? (
                  <div
                    style={{
                      width: "100%",
                      minHeight: "20vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ProgressSpinner style={{ top: "230px" }} />
                  </div>
                ) : (
                  <TabView
                    activeIndex={activeStaffCalendarIndex}
                    onTabChange={(e) => setActiveStaffCalendarIndex(e.index)}
                    panelContainerStyle={{
                      background: "rgba(0,0,0,0)",
                      padding: 0,
                    }}
                  >
                    <TabPanel header="Scheduling">
                      <div hidden={!isCalendarView.staffCalendar}>
                        <Calendar
                          inline
                          value={date}
                          viewDate={selectedDateView?.from}
                          onViewDateChange={(ev) =>
                            setSelectedDateViewValue(ev.value)
                          }
                          onChange={(e) => updateList(e.value)}
                          style={{
                            marginTop: "5px",
                            width: "100%",
                            pDatepickerCurrentDay: { background: "red" },
                          }}
                        ></Calendar>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              border: "2px solid #8C28E4",
                              borderRight: 0,
                              borderBottomLeftRadius: "2px",
                              width: "30%",
                              height: "300px",
                              padding: "10px 30px 30px 30px",
                              fontFamily: "Lato",
                              overflow: "auto",
                            }}
                          >
                            <h3>Recurring Controllers</h3>
                            <br />
                            {recurringStaffControllers.map((obj, i) => {
                              return (
                                <div
                                  key={i}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <div className="">
                                    <b style={{ color: "#666666" }}>
                                      {obj.frequency}
                                    </b>
                                    <br />
                                    <span style={{ color: "#666666" }}>
                                      {" with "}
                                    </span>
                                    <GetParticipantLink
                                      participant_name={obj.participantName}
                                      participant_id={extractSoarId(obj)}
                                      participant_alias={obj.caseId}
                                      appt={obj}
                                    />
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div
                            style={{
                              border: "2px solid #8C28E4",
                              width: "70%",
                              borderBottomRightRadius: "12px",
                              height: "300px",
                              padding: "10px 30px 30px 30px",
                              fontFamily: "Lato",
                              overflow: "auto",
                            }}
                          >
                            <h3>Appointments</h3>
                            <br />
                            {activeStaffCalendarArray
                              .filter((x) => {
                                let startUnix = getDate(
                                  x.startDateTime,
                                ).toUnixInteger()
                                let selectedUnix =
                                  DateTime.fromJSDate(date).toUnixInteger()
                                return (
                                  startUnix > selectedUnix &&
                                  startUnix <
                                    DateTime.fromJSDate(date)
                                      .plus({ days: 1 })
                                      .toUnixInteger()
                                )
                              })
                              .map((obj, i) => {
                                return (
                                  <div
                                    key={i}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <div className="">
                                      <b style={{ color: "#666666" }}>
                                        {getDate(obj.startDateTime).toFormat(
                                          "h:mm a",
                                        )}
                                      </b>
                                      <br />
                                      <span style={{ color: "#666666" }}>
                                        {" "}
                                        {obj.engagementType + " with "}
                                      </span>
                                      <GetParticipantLink
                                        participant_name={obj.participantName}
                                        participant_alias={obj.caseId}
                                        participant_id={extractSoarId(obj)}
                                        appt={obj}
                                      />
                                    </div>

                                    {activeStaffCalendarContext ===
                                    "Pending Appointments" ? (
                                      formatPendingActions(obj)
                                    ) : activeStaffCalendarContext ===
                                      "Upcoming Appointments" ? (
                                      <button
                                        type="submit"
                                        className="btn-sm"
                                        style={{ display: "block" }}
                                        onClick={() => openEditModal(obj)}
                                      >
                                        Edit Appointment
                                      </button>
                                    ) : null}
                                  </div>
                                )
                              })}
                          </div>
                        </div>
                      </div>
                      <div hidden={isCalendarView.staffCalendar}>
                        <TabView
                          activeIndex={activeStaffSchedulingIndex}
                          onTabChange={(e) =>
                            setActiveStaffSchedulingIndex(e.index)
                          }
                          panelContainerStyle={{
                            background: "rgba(0,0,0,0)",
                            padding: 0,
                            marginLeft: "-35px",
                          }}
                        >
                          <TabPanel header="Pending Appointments">
                            <AppointmentsTablePending
                              pendingAppointments={pendingAppointments.filter(
                                (x) =>
                                  x.type !== "DECLINED" &&
                                  x.type !== "BOOKED" &&
                                  x.type !== "CANCELLED" &&
                                  x.type !== "CANCELLED.DENIED",
                              )}
                              getParticipantColumnBody={ParticipantColumnBody}
                              getPendingActionsColumnBody={formatPendingActions}
                            />
                          </TabPanel>
                          <TabPanel header="Declined Appointments">
                            <AppointmentsTableDeclined
                              declinedAppointments={pendingAppointments.filter(
                                (x) =>
                                  x.type === "DECLINED" ||
                                  x.type === "CANCELLED.DENIED",
                              )}
                              GetParticipantColumnBody={ParticipantColumnBody}
                            />
                          </TabPanel>
                          <TabPanel header="Past Appointments">
                            <DataTable
                              value={pastAppointments}
                              sortField="startDateTime"
                              sortOrder={1}
                            >
                              <Column
                                field="startDateTime"
                                sortable
                                header="Date"
                                body={formatOrgCalDate}
                              />
                              <Column
                                field="engagementType"
                                sortable
                                header="Engagement Type"
                              />
                              <Column
                                field="engagementChannel"
                                sortable
                                bodyStyle={{ textTransform: "capitalize" }}
                                header="Engagement Channel"
                              />
                              <Column
                                field="scheduledTime"
                                sortable
                                header="Scheduled Time"
                              />
                              <Column
                                body={ParticipantColumnBody}
                                field="participantName"
                                sortable
                                header="Participant"
                              />
                              <Column
                                field="fromBehalfOf"
                                sortable
                                header="Staff Assigner"
                              />
                            </DataTable>
                          </TabPanel>
                          <TabPanel header="Upcoming Appointments">
                            <DataTable
                              value={upcomingAppointments}
                              sortField="startDateTime"
                              sortOrder={1}
                            >
                              <Column
                                field="startDateTime"
                                sortable
                                header="Date"
                                body={formatOrgCalDate}
                              />
                              <Column
                                field="engagementType"
                                sortable
                                header="Engagement Type"
                              />
                              <Column
                                field="engagementChannel"
                                sortable
                                bodyStyle={{ textTransform: "capitalize" }}
                                header="Engagement Channel"
                              />
                              <Column
                                sortable
                                header="Scheduled Time"
                                field="scheduledTime"
                              />
                              <Column
                                body={ParticipantColumnBody}
                                field="participantName"
                                sortable
                                header="Participant"
                              />
                              <Column
                                field="fromBehalfOf"
                                sortable
                                header="Staff Assigner"
                              />
                            </DataTable>
                          </TabPanel>
                          <TabPanel header="Scheduled Recurring Appointments">
                            <DataTable
                              value={recurringStaffControllers}
                              sortField="startDateTime"
                              sortOrder={1}
                            >
                              <Column field="newFreq" sortable header="Date" />
                              <Column
                                field="engagementType"
                                sortable
                                header="Engagement Type"
                              />
                              <Column
                                field="engagementChannel"
                                sortable
                                bodyStyle={{ textTransform: "capitalize" }}
                                header="Engagement Channel"
                              />
                              <Column
                                field="range"
                                sortable
                                header="Range"
                                body={(obj) => {
                                  return (
                                    getDate(obj.startDate).toFormat(
                                      "MM/dd/yyyy",
                                    ) +
                                    " - " +
                                    getDate(obj.endDate).toFormat("MM/dd/yyyy")
                                  )
                                }}
                              />
                              <Column
                                field="scheduledTime"
                                sortable
                                header="Scheduled Time"
                              />
                              <Column
                                body={ParticipantColumnBody}
                                field="participantName"
                                sortable
                                header="Participant"
                              />
                              <Column
                                field="fromBehalfOf"
                                sortable
                                header="Staff Assigner"
                              />
                            </DataTable>
                          </TabPanel>
                        </TabView>
                      </div>
                    </TabPanel>
                    <TabPanel header="Availability">
                      <TabView
                        activeIndex={activeStaffAvailabilityIndex}
                        onTabChange={(e) =>
                          setActiveStaffAvailabilityIndex(e.index)
                        }
                        panelContainerStyle={{
                          background: "rgba(0,0,0,0)",
                          padding: 0,
                        }}
                      >
                        <TabPanel header="Active Availability">
                          <DataTable
                            value={activeAvailabilities}
                            sortField="startDateTime"
                            sortOrder={1}
                          >
                            <Column
                              sortable
                              header="Available Date"
                              body={formatAvailDate}
                            />
                            <Column
                              sortable
                              header="Available Time"
                              body={formatAvailTime}
                            />
                            <Column
                              sortable
                              header="Timezone"
                              body={formatAvailTimezone}
                            />
                            <Column
                              sortable
                              header="Recurring Rules"
                              body={formatRecurringRules}
                            />
                            <Column
                              field="appointmentBuffer"
                              sortable
                              header="Appointment Buffer"
                            />
                            <Column
                              field="fromBehalfOf"
                              sortable
                              header="Staff Assigner"
                            />
                            <Column
                              field="action"
                              header="Action"
                              body={formatAvailActions}
                            />
                          </DataTable>
                        </TabPanel>
                        <TabPanel header="Past Availability">
                          <DataTable
                            value={pastAvailabilities}
                            sortField="startDateTime"
                            sortOrder={1}
                          >
                            <Column
                              sortable
                              header="Available Date"
                              body={formatAvailDate}
                            />
                            <Column
                              sortable
                              header="Available Time"
                              body={formatAvailTime}
                            />
                            <Column
                              sortable
                              header="Timezone"
                              body={formatAvailTimezone}
                            />
                            <Column
                              sortable
                              header="Recurring Rules"
                              body={formatRecurringRules}
                            />
                            <Column
                              field="fromBehalfOf"
                              sortable
                              header="Staff Assigner"
                            />
                            <Column
                              field="appointmentBuffer"
                              sortable
                              header="Appointment Buffer"
                            />
                          </DataTable>
                        </TabPanel>
                      </TabView>
                    </TabPanel>
                  </TabView>
                )}
              </div>
            </div>
          </>
        )}
      </Dialog>

      {/* Dialog for Creating/Editing Appointments */}
      <Dialog
        header={() => (
          <div style={{ paddingLeft: "10px" }}>
            <h4
              style={{
                margin: 0,
                marginBottom: "15px",
                color: "#757575",
                fontSize: "20px",
              }}
            >
              {apptModalMode}
            </h4>
          </div>
        )}
        visible={modalIsOpen}
        onHide={() => setIsOpen(false)}
        style={{ width: "664px" }}
        headerStyle={{ paddingBottom: "0px" }}
        footer={() => (
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              onClick={() => setIsOpen(false)}
              className="btn"
              style={{ marginRight: "5px" }}
            >
              Close
            </Button>
            {activeAppointment.values.id !== 0 ? (
              <Button
                onClick={async () => {
                  if (
                    activeAppointment.values.isRecurringController &&
                    activeMainIndex.code == 1
                  ) {
                    await deleteOrgController(
                      userCtx.tokens.getAppointmentsToken(),
                      activeAppointment.values.id,
                    )
                    cancelAppt(true, false)
                  } else cancelAppt(false, false)
                }}
                className="btn"
                style={{ marginRight: "5px" }}
              >
                Cancel Appointment
              </Button>
            ) : null}
            <Button
              label={
                apptModalMode.includes("Submit")
                  ? "Schedule Appointment"
                  : "Edit Appointment"
              }
              type="submit"
              className={styles.btn}
              onClick={() => submitNewAppointment()}
            />
          </div>
        )}
      >
        <form
          onSubmit={activeAppointment.handleSubmit}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
          }}
        >
          {toggleRecurringAppt()}
          <div
            hidden={apptModalMode.includes("Edit")}
            style={{
              ...customStyles.inputField,
              width: "95%",
              marginBottom: "10px",
            }}
          >
            <Checkbox
              id="isRecurringController"
              onChange={activeAppointment.handleChange}
              checked={activeAppointment.values.isRecurringController}
            ></Checkbox>{" "}
            <label htmlFor="startDate">Recurring Appointment</label>
          </div>
          <div style={{ ...customStyles.inputField, width: "95%" }}>
            <label htmlFor="startDate">Timezone</label>
            <br />
            <Dropdown
              id="timezone"
              onChange={(e) => {
                const newStartTime = DateTime.fromJSDate(
                  activeAppointment.values.startTime,
                )
                  .setZone(activeAppointment.values.timezone?.code)
                  .setZone(e.value?.code, {
                    keepLocalTime: true,
                  })

                activeAppointment.setFieldValue(
                  "startTime",
                  newStartTime.toJSDate(),
                )
                activeAppointment.setFieldValue(e.target.id, e.value)
              }}
              value={activeAppointment.values.timezone}
              style={customStyles.inputStyle}
              options={timezones}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "timezone"),
              })}
              optionLabel="name"
              disabled={apptModalMode.includes("Edit")}
            />
          </div>
          <div style={{ ...customStyles.inputField, width: "95%" }}></div>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Appointment Type</label>
            <br />
            <Dropdown
              id="serviceName"
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.serviceName}
              style={customStyles.inputStyle}
              options={services}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "serviceName"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">Duration</label>
            <br />
            <Dropdown
              id="duration"
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.duration}
              style={customStyles.inputStyle}
              options={durations}
              optionLabel="name"
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "duration"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Engagement Channel</label>
            <br />
            <Dropdown
              id="engagementChannel"
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.engagementChannel}
              style={{
                ...customStyles.inputStyle,
                textTransform: "capitalize",
              }}
              panelStyle={{ textTransform: "capitalize" }}
              options={engagementChannels}
              className={classNames({
                "p-invalid": isFormFieldValid(
                  activeAppointment,
                  "engagementChannel",
                ),
              })}
            />
          </div>
          {editChannelSelect(activeAppointment)}
          <div style={{ ...customStyles.inputField, width: "95%" }}>
            <label htmlFor="startDate">Participant</label>
            <br />
            <Dropdown
              id="participant"
              disabled={apptModalMode.includes("Edit")}
              onChange={activeAppointment.handleChange}
              value={activeAppointment.values.participant}
              style={customStyles.inputStyle}
              optionLabel="name"
              options={participants}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "participant"),
              })}
              filter
            />
          </div>
          <div style={customStyles.inputField}>
            <Checkbox
              id="sendEmailNotifications"
              onChange={activeAppointment.handleChange}
              checked={activeAppointment.values.sendEmailNotifications}
            ></Checkbox>{" "}
            <label htmlFor="startDate">Send Email Notifications</label>
          </div>
          <div style={customStyles.inputField}>
            <Checkbox
              id="sendSMSNotifications"
              onChange={activeAppointment.handleChange}
              checked={activeAppointment.values.sendSMSNotifications}
            ></Checkbox>{" "}
            <label htmlFor="startDate">Send SMS Notifications</label>
          </div>
        </form>
      </Dialog>

      {/* Dialog for Confirming Actions */}
      <Dialog
        header={() => (
          <div style={{ paddingLeft: "10px" }}>
            <h4
              style={{
                margin: 0,
                marginBottom: "15px",
                color: "#757575",
                fontSize: "20px",
              }}
            >
              Confirm Action
            </h4>
          </div>
        )}
        visible={confirmModalIsOpen}
        onHide={() => setConfirmIsOpen(false)}
        style={{ width: "25%" }}
        headerStyle={{ paddingBottom: "0px" }}
        footer={() => (
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              onClick={() => setConfirmIsOpen(false)}
              className="btn"
              style={{ marginRight: "5px" }}
            >
              Cancel
            </Button>
            <Button
              label="Confirm"
              type="submit"
              className={styles.btn}
              onClick={() => confirmAction()}
            />
          </div>
        )}
      >
        <h3>{confirming.message}</h3>
      </Dialog>

      {/* Dialog for Creating/Editing Availability */}
      <Dialog
        header={() => (
          <div style={{ paddingLeft: "10px" }}>
            <h4
              style={{
                margin: 0,
                marginBottom: "15px",
                color: "#757575",
                fontSize: "20px",
              }}
            >
              {availModalMode}
            </h4>
          </div>
        )}
        visible={availabilityModalIsOpen}
        onHide={() => setAvailabilityIsOpen(false)}
        style={{ width: "600px", maxWidth: "90vw" }}
        headerStyle={{ paddingBottom: "0px" }}
        footer={() => (
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              onClick={() => setAvailabilityIsOpen(false)}
              className="btn"
              style={{ marginRight: "5px" }}
            >
              Close
            </Button>
            <Button
              label="Save"
              type="submit"
              className={styles.btn}
              onClick={() => saveAvailability()}
            />
          </div>
        )}
      >
        <form
          onSubmit={activeAvailability.handleSubmit}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
          }}
        >
          {toggleRecurringAvail()}
          <div
            hidden={availModalMode.includes("Edit")}
            style={{
              ...customStyles.inputField,
              width: "95%",
              marginBottom: "10px",
            }}
          >
            <Checkbox
              id="isRecurring"
              onChange={activeAvailability.handleChange}
              checked={activeAvailability.values.isRecurring}
            ></Checkbox>{" "}
            <label htmlFor="startDate">Recurring Availability</label>
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startTime">Appointment Buffer</label>
            <br />
            <Dropdown
              id="appointmentBuffer"
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.appointmentBuffer}
              style={customStyles.inputStyle}
              options={durations.slice(0, 4)}
              optionLabel="name"
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "duration"),
              })}
            />
          </div>
          <div style={customStyles.inputField}>
            <label htmlFor="startDate">Timezone</label>
            <br />
            <Dropdown
              id="timezone"
              onChange={activeAvailability.handleChange}
              value={activeAvailability.values.timezone}
              style={customStyles.inputStyle}
              options={timezones}
              className={classNames({
                "p-invalid": isFormFieldValid(activeAppointment, "timezone"),
              })}
              optionLabel="name"
            />
          </div>
        </form>
      </Dialog>
    </>
  )
}
